function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};
function stringifyPrimitive(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
}

function stringify (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
}
function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

function parse(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
}var querystring = {
  encode: stringify,
  stringify: stringify,
  decode: parse,
  parse: parse
};

var config = {
  version: '1.13.3',
  versionFmt: ''
};

var EventSpm = 'event:spm';
var EventPageView = 'event:pageview';
var PageViewData = 'pageview:data';
var BeforePageViewData = 'before:pv:data';
var EventPrePush = 'event:pre-push';
var EventReadyPush = 'event:ready-push';
var EventPushFail = 'event:push-fail';
var EventPushSuccess = 'event:push-success';
var EventPreparePushExposure = 'event:pre:exposure';
var EventExposure = 'event:exposure:success';
var EventCustom = 'event:custom';
var CustomData = 'custom:data';
var BeforeCustomData = 'before:custom:data';
var EventAction = 'event:action';
var EventVirtualAction = 'event:virtual:action';
var ExposureSyncKey = 'local:exposure:key';
var LocalConfigKey = 'local:config';
var Manual = 'manual';
var ConfigChangeEvent = 'config:change';
var ServerTimeInvalid = 'ServerTimeInvalid';
var InhouseInit = 'init';
var InhouseInitReady = 'init-ready';
var RequestSuccess = 'request:success';
var RequestFinish = 'request:finish';
var RequestFail = 'request:fail';
var SpmTypeMap = {
  page: 'data-spm-page',
  module: 'data-spm-module',
  item: 'data-spm-item',
  virtualItem: 'data-spm-virtual-item'
};
var SpmKeyMap = {
  custom: 'page',
  page: 'page',
  item: 'item',
  virtualItem: 'item',
  module: 'module'
};
var AsyncDataCache = 'A._dataCache';
var ApplicationJson = 'application/json';

var Constants = {
  __proto__: null,
  EventSpm: EventSpm,
  EventPageView: EventPageView,
  PageViewData: PageViewData,
  BeforePageViewData: BeforePageViewData,
  EventPrePush: EventPrePush,
  EventReadyPush: EventReadyPush,
  EventPushFail: EventPushFail,
  EventPushSuccess: EventPushSuccess,
  EventPreparePushExposure: EventPreparePushExposure,
  EventExposure: EventExposure,
  EventCustom: EventCustom,
  CustomData: CustomData,
  BeforeCustomData: BeforeCustomData,
  EventAction: EventAction,
  EventVirtualAction: EventVirtualAction,
  ExposureSyncKey: ExposureSyncKey,
  LocalConfigKey: LocalConfigKey,
  Manual: Manual,
  ConfigChangeEvent: ConfigChangeEvent,
  ServerTimeInvalid: ServerTimeInvalid,
  InhouseInit: InhouseInit,
  InhouseInitReady: InhouseInitReady,
  RequestSuccess: RequestSuccess,
  RequestFinish: RequestFinish,
  RequestFail: RequestFail,
  SpmTypeMap: SpmTypeMap,
  SpmKeyMap: SpmKeyMap,
  AsyncDataCache: AsyncDataCache,
  ApplicationJson: ApplicationJson
};

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}
function isArray$1(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}
function isFunction(value) {
  return Object.prototype.toString.call(value) === '[object Function]';
}
/**
 * Merge 对象，不改变原对象
 * @param args 参数列表
 * @return 合并后的新对象
 */

function deepMerge() {
  var result = {};

  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var obj = _args[_i];

    if (isObject(obj)) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          var value = obj[key];

          if (isObject(value)) {
            if (result[key]) {
              result[key] = deepMerge(result[key], value);
            } else {
              result[key] = deepMerge(value);
            }
          } else {
            if (value !== undefined) {
              result[key] = value;
            }
          }
        }
      }
    }
  }

  return result;
}
/**
 * 获取 Query 参数的值
 * @param url URL
 * @param key 参数名
 * @return 参数值
 */

function getQueryParam(url, key) {
  key = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
  var result = regex.exec(url);

  if (!result || result && typeof result[1] !== 'string') {
    return '';
  } else {
    var value = result[1];

    try {
      value = decodeURIComponent(value);
    } catch (err) {
      console.error('Skipping decoding for malformed query param: ' + value);
    }

    return value.replace(/\+/g, ' ');
  }
}
/**
 * 获取 Query 中某个字段的值，如果是数组则返回第一个元素
 * @param query 解析后的 Query
 * @param key 字段
 */

function getQueryValue(query, key, toNumber) {
  if (toNumber === void 0) {
    toNumber = false;
  }

  var value = query[key];
  var result = isArray$1(value) ? value[0] : value;
  return toNumber && result ? Number(result) : result;
}
/**
 * json 序列化，将 key 转换为 snake_case 命名
 * @param value 输入值
 * @param ignoreObjKey 忽略转化的对象的 key
 */

function json2string(value, ignoreObjKey) {
  if (ignoreObjKey === void 0) {
    ignoreObjKey = 'extra';
  }

  var ignoreKeys = [];
  ignoreKeys = ignoreKeys.concat(ignoreObjKey);
  return JSON.stringify(value, function (_key, value) {
    if (isObject(value) && !ignoreKeys.includes(_key)) {
      var replacement = {};

      for (var k in value) {
        if (Object.hasOwnProperty.call(value, k)) {
          if (ignoreKeys.includes(k)) {
            var key = k.replace(/^[A-Z]/, function (letter) {
              return "" + letter.toLowerCase();
            });
            key = key.replace(/[A-Z]/g, function (letter) {
              return "_" + letter.toLowerCase();
            });

            if (!ignoreKeys.includes(key)) {
              ignoreKeys.push(key);
            }

            replacement[key] = value[k];
          } else {
            var _key3 = k.replace(/^[A-Z]/, function (letter) {
              return "" + letter.toLowerCase();
            });

            _key3 = _key3.replace(/[A-Z]/g, function (letter) {
              return "_" + letter.toLowerCase();
            });
            replacement[_key3] = value[k];
          }
        }
      }

      return replacement;
    }

    return value;
  });
}

function isEmpty(foo) {
  if (foo && typeof foo === 'object') {
    return Object.keys(foo).length === 0;
  } else {
    return foo === '' || foo === null || foo === undefined;
  }
}
/**
 * 去掉值为 undefined 的字段
 * @param obj 对象
 */


function stripUndefinedFields(obj) {
  var result = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] !== undefined) {
        result[key] = obj[key];
      }
    }
  }

  return result;
}
function deepCompactObj(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var item = obj[key];

      if (isEmpty(item)) {
        delete obj[key];
      } else if (item && typeof item === 'object') {
        deepCompactObj(item);
      }
    }
  }
}
function isiOS() {
  var ua = navigator && navigator.userAgent;
  return /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(ua);
}
function isAndroid() {
  var ua = navigator && navigator.userAgent.toLowerCase();
  return ua.includes('android');
}
function isIe() {
  var hasActiveX = Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, 'ActiveXObject') || 'ActiveXObject' in window;
  return Boolean(hasActiveX);
}
function isSearchBot() {
  var ua = navigator && navigator.userAgent;
  var crawlerRegex = new RegExp('7COhgMEm|oncrawl|naver.me/spd|spider|bot|crawler|externalhit|(bingpreview)|(ysearch/slurp)|(http://naver.me/spd)');
  if (crawlerRegex.test(ua)) return true;
  return /(Sogou web spider)|(bingbot)|(Googlebot)|(Baiduspider)|(AdsBot)|(TweetmemeBot)|(Slackbot)|(James BOT)|(Applebot)|(Facebot)|(YandexMobileBot)|(AhrefsBot)|(contxbot)|(Livechat OpenGraph Robot)|(Mail.RU_Bot)|(archive.org_bot)|(MojeekBot)|(Discordbot)|(startmebot)/i.test(ua);
}
function isInApp() {
  var ua = navigator && navigator.userAgent.toLowerCase();
  return ua.includes('klook');
} // export function lastCall<T extends (...args: any) => any>(
//   func: T,
//   wait: number = 1000
// ) {
//   let timeId: any = 0
//   return (...args: any) => {
//     // @ts-ignore
//     const lastThis = this
//     if (timeId) {
//       clearTimeout(timeId)
//     }
//     timeId = setTimeout(() => {
//       func.apply(lastThis, args)
//     }, wait)
//   }
// }

var uuidv4 = function uuidv4() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
};
function uuid() {
  try {
    return uuidv4();
  } catch (e) {
    var _window$performance, _window$performance2;

    var _uid = (_window$performance = window.performance) !== null && _window$performance !== void 0 && _window$performance.now ? (_window$performance2 = window.performance) === null || _window$performance2 === void 0 ? void 0 : _window$performance2.now() : getNow();

    return String(_uid);
  }
}
function uidWithVersion() {
  var uid = uuid();
  if (!config.versionFmt) config.versionFmt = config.version.split('.').join('');
  return config.versionFmt + "-" + uid.slice(config.versionFmt.length, uid.length);
}
function getNow() {
  return Date.now ? Date.now() : +new Date();
}
var toSelf = function toSelf(v) {
  return v;
};
function transformObj(obj, transform) {
  if (transform === void 0) {
    transform = toSelf;
  }

  var result = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] !== undefined) {
        result[key] = transform(obj[key], key, obj);
      }
    }
  }

  return result;
}
function getFromCookie(key) {
  var cookies = document.cookie ? document.cookie.split('; ') : [];
  var jar = {};

  function defaultConverterRead(value) {
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  }

  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split('=');
    var value = parts.slice(1).join('=');

    if (value[0] === '"') {
      value = value.slice(1, -1);
    }

    try {
      var foundKey = defaultConverterRead(parts[0]);
      jar[foundKey] = defaultConverterRead(value);

      if (key === foundKey) {
        break;
      }
    } catch (e) {}
  }

  return key ? jar[key] : null;
}

function encodeStr(str) {
  // return encodeURIComponent(str)
  return str;
}

var joinClickSpmToUrl = function joinClickSpmToUrl(url, spm, clickId) {
  var href = String(url || '').trim();
  if (!href) return '';
  if (!spm || !clickId) return url;
  var anchorArr = href.split('#');
  var urlArr = anchorArr[0].split('?');
  var hrefArr = [urlArr[0], urlArr[1] || '', anchorArr[1]];
  var spmObj = {};

  if (spm && spm !== 'unknown') {
    spmObj = {
      spm: encodeStr(spm),
      clickId: encodeStr(clickId || '')
    };
  }

  var urlObj = querystring.parse(hrefArr[1]);
  hrefArr[1] = querystring.stringify(_extends({}, urlObj, spmObj));
  var finalHref = hrefArr[0] + (hrefArr[1] ? "?" + hrefArr[1] : '') + ("" + (hrefArr[2] ? '#' + hrefArr[2] : ''));
  return finalHref;
};
var getClickInfo = function getClickInfo() {
  var search = window.location.search || '';
  if (!search.includes('spm=')) return {};
  search = search.replace(/^\?/, '');
  var queryMap = querystring.parse(search);

  if (queryMap.spm) {
    var res = {
      clickSpm: String(queryMap.spm)
    };

    if (queryMap.clickId) {
      res.clickId = String(queryMap.clickId);
    }

    return res;
  }

  return {};
};
function findLatestElement(root, stopCb, opt) {
  var _opt;

  if (opt === void 0) {
    opt = {
      stopTag: 'BODY'
    };
  }

  var current = root;
  var flag = 0;
  var stopTag = (_opt = opt) === null || _opt === void 0 ? void 0 : _opt.stopTag;

  while (current) {
    if (stopTag && current.tagName === stopTag) return null;
    flag = stopCb(current);

    if (flag === 1) {
      return current;
    }

    if (flag === -1) break;
    current = current.parentElement || current.parentNode;
  }

  return null;
}
function objMapFilter(obj, cb, filter) {
  if (filter === void 0) {
    filter = function filter(_, val) {
      return val !== undefined;
    };
  }

  var result = {};
  Object.keys(obj).forEach(function (i) {
    if (filter(i, obj[i], obj)) {
      var val = cb(i, obj[i], obj);
      result[i] = val;
    }
  });
  return result;
}
function encodeSpm(spm, obj) {
  var result = spm ? spm + '?' : '';
  var query = '';

  if (obj) {
    var q = objMapFilter(obj, function (k, val) {
      if (k === 'ext' && val && isObject(val)) {
        return encodeURIComponent(JSON.stringify(val));
      }

      return val;
    });
    query = querystring.stringify(q);
  }

  return result + query;
}
var retry = function retry(fn, option) {
  var _ref = option || {},
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 1 : _ref$count,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? null : _ref$context,
      args = _ref.args;

  var next = function next(n) {
    if (n > count) return;
    fn === null || fn === void 0 ? void 0 : fn.call(context, args, function () {
      return next(n + 1);
    });
  };

  next(1);
};
function isNil(k) {
  return k == null;
}
function pick(obj, from, list) {
  list.forEach(function (k) {
    var val = k && from[k];

    if (!isNil(val)) {
      obj[k] = val;
    }
  });
  return obj;
}
function isString(value) {
  return typeof value === 'string';
}
function isSpecialLink(href) {
  if ((href.startsWith('javascript') || href.startsWith('void')) && !href.includes('/')) return true;
  return href.startsWith('#');
}
function querySelector(selectors) {
  return document.querySelector(selectors);
}
function hasTrackerInfo(node) {
  return Object.keys(SpmTypeMap).find(function (key) {
    var selectors = SpmTypeMap[key];
    return node.getAttribute(selectors);
  });
}
function mergeData(data, layers) {
  var result = data;
  layers.forEach(function (layer) {
    result = deepMerge(result, layer);
  });
  return result;
}
function runQueue(queue, fn, cb) {
  var step = function step(index) {
    if (index >= queue.length) {
      cb && cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };

  step(0);
}
function forEach(list, fn) {
  if (!list) return;

  if (Array.isArray(list)) {
    list.forEach(function (item, key) {
      return fn(item, key);
    });
  } else {
    Object.keys(list).forEach(function (key) {
      return fn(list[key], key);
    });
  }
}

var Logger = /*#__PURE__*/function () {
  function Logger(options) {
    if (options === void 0) {
      options = {};
    }

    this.options = {
      debug: false,
      prefix: '[Inhouse Tracking]',
      name: '',
      colors: {
        info: '#09f',
        warn: '#f90',
        error: '#f66'
      }
    };
    this.set(options);
  }

  var _proto = Logger.prototype;

  _proto.set = function set(options) {
    if (options === void 0) {
      options = {};
    }

    this.options = deepMerge(this.options, options, {});
    var _this$options = this.options,
        name = _this$options.name,
        prefix = _this$options.prefix;

    if (name) {
      this.options.prefix = prefix + ("[" + name + "]");
    }
  };

  _proto.log = function log(type) {
    var _this$options2 = this.options,
        debug = _this$options2.debug,
        prefix = _this$options2.prefix,
        colors = _this$options2.colors;

    if (debug) {
      var _console2;

      var style = colors ? "color: " + colors[type] : '';

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (type === 'warn') {
        var _console;

        (_console = console).warn.apply(_console, ["%c" + prefix + " " + type.toUpperCase(), style].concat(args));

        return;
      }

      (_console2 = console).log.apply(_console2, ["%c" + prefix + " " + type.toUpperCase(), style].concat(args));
    }
  };

  _proto.info = function info() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    this.log.apply(this, ['info'].concat(args));
  };

  _proto.warn = function warn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    this.log.apply(this, ['warn'].concat(args));
  };

  _proto.error = function error() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    this.log.apply(this, ['error'].concat(args));
  };

  return Logger;
}();

/**
 * Ref: https://github.com/mixpanel/mixpanel-js
 */

var Detector = /*#__PURE__*/function () {
  function Detector() {
    this._opera = !!window.opera;
    this._vendor = window.navigator.vendor;
    this.userAgent = window.navigator.userAgent;
    this.referrer = window.document.referrer || 'direct';
    this.referringDomain = this.referrer !== 'direct' ? this.getReferringDomain(this.referrer) : 'direct';
    this.os = this.getOS(this.userAgent);
    this.webviewOS = this.getWebviewOS(this.userAgent);
    this.browser = this.getBrowser(this.userAgent, this._vendor, this._opera);
    this.browserVersion = this.getBrowserVersion(this.userAgent, this._vendor, this._opera);
    this.device = this.getDevice(this.userAgent);
    this.searchEngine = this.getSearchEngine(this.referrer);
    this.screen = {
      width: window.screen.width,
      height: window.screen.height
    };
  }

  var _proto = Detector.prototype;

  _proto.getReferrer = function getReferrer(url) {
    var referrer = window.document.referrer || url || '';
    var referringDomain = this.getReferringDomain(referrer);
    return {
      referrer: referrer || 'direct',
      referringDomain: referringDomain || 'direct'
    };
  };

  _proto.getReferrerOfUrl = function getReferrerOfUrl(url) {
    var referrer = url || '';
    var referringDomain = this.getReferringDomain(referrer);
    return {
      referrer: referrer || 'direct',
      referringDomain: referringDomain || 'direct'
    };
  };

  _proto.getSearchEngine = function getSearchEngine(referrer) {
    if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
      return 'google';
    } else if (referrer.search('https?://(.*)bing.com') === 0) {
      return 'bing';
    } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
      return 'yahoo';
    } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
      return 'duckduckgo';
    } else {
      return null;
    }
  };

  _proto.getSearchInfo = function getSearchInfo(referrer) {
    var search = this.getSearchEngine(referrer);
    var key = search !== 'yahoo' ? 'q' : 'p';
    var result = {};

    if (search !== null) {
      result['searchEngine'] = search;
      var keyword = getQueryParam(referrer, key);

      if (keyword.length) {
        result['keyword'] = keyword;
      }
    }

    return result;
  }
  /**
   * This function detects which browser is running this script.
   * The order of the checks are important since many user agents
   * include key words used in later checks.
   */
  ;

  _proto.getBrowser = function getBrowser(userAgent, vendor, opera) {
    vendor = vendor || ''; // vendor is undefined for at least IE9

    if (opera || userAgent.includes(' OPR/')) {
      if (userAgent.includes('Mini')) {
        return 'Opera Mini';
      }

      return 'Opera';
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
      return 'BlackBerry';
    } else if (userAgent.includes('IEMobile') || userAgent.includes('WPDesktop')) {
      return 'Internet Explorer Mobile';
    } else if (userAgent.includes('SamsungBrowser/')) {
      // https://developer.samsung.com/internet/user-agent-string-format
      return 'Samsung Internet';
    } else if (userAgent.includes('Edge') || userAgent.includes('Edg/')) {
      return 'Microsoft Edge';
    } else if (userAgent.includes('FBIOS')) {
      return 'Facebook Mobile';
    } else if (userAgent.includes('Chrome')) {
      return 'Chrome';
    } else if (userAgent.includes('CriOS')) {
      return 'Chrome iOS';
    } else if (userAgent.includes('UCWEB') || userAgent.includes('UCBrowser')) {
      return 'UC Browser';
    } else if (userAgent.includes('FxiOS')) {
      return 'Firefox iOS';
    } else if (vendor.includes('Apple')) {
      if (userAgent.includes('Mobile')) {
        return 'Mobile Safari';
      }

      return 'Safari';
    } else if (userAgent.includes('Android')) {
      return 'Android Mobile';
    } else if (userAgent.includes('Konqueror')) {
      return 'Konqueror';
    } else if (userAgent.includes('Firefox')) {
      return 'Firefox';
    } else if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) {
      return 'Internet Explorer';
    } else if (userAgent.includes('Gecko')) {
      return 'Mozilla';
    } else {
      return '';
    }
  }
  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  ;

  _proto.getBrowserVersion = function getBrowserVersion(userAgent, vendor, opera) {
    var browser = this.getBrowser(userAgent, vendor, opera);
    var versionRegexs = {
      'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
      'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
      'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      'Opera Mini': /Opera Mini\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      'Android Mobile': /android\s(\d+(\.\d+)?)/,
      'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
      'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/
    };
    var regex = versionRegexs[browser];

    if (regex === undefined) {
      return null;
    }

    var matches = userAgent.match(regex);

    if (!matches) {
      return null;
    }

    return parseFloat(matches[matches.length - 2]);
  };

  _proto.getOS = function getOS(userAgent) {
    if (/Windows/i.test(userAgent)) {
      if (/Phone/.test(userAgent) || /WPDesktop/.test(userAgent)) {
        return 'Windows Phone';
      }

      return 'Windows';
    } else if (/(iPhone|iPad|iPod)/.test(userAgent)) {
      return 'iOS';
    } else if (/Android/.test(userAgent)) {
      return 'Android';
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
      return 'BlackBerry';
    } else if (/Mac/i.test(userAgent)) {
      return 'Mac OS X';
    } else if (/Linux/.test(userAgent)) {
      return 'Linux';
    } else if (/CrOS/.test(userAgent)) {
      return 'Chrome OS';
    } else {
      return '';
    }
  };

  _proto.getAppOs = function getAppOs() {
    if (isAndroid()) {
      return 'android';
    } else if (isiOS()) {
      console.log('ios');
      return 'ios';
    }

    return '';
  };

  _proto.getDevice = function getDevice(userAgent) {
    if (/Windows Phone/i.test(userAgent) || /WPDesktop/.test(userAgent)) {
      return 'Windows Phone';
    } else if (/iPad/.test(userAgent)) {
      return 'iPad';
    } else if (/iPod/.test(userAgent)) {
      return 'iPod Touch';
    } else if (/iPhone/.test(userAgent)) {
      return 'iPhone';
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(userAgent)) {
      return 'BlackBerry';
    } else if (/Android/.test(userAgent)) {
      return 'Android';
    } else {
      return '';
    }
  };

  _proto.getWebviewOS = function getWebviewOS(userAgent) {
    if (/klook/i.test(userAgent)) {
      return this.getAppOs() || null;
    }

    return null;
  };

  _proto.getReferringDomain = function getReferringDomain(referrer) {
    var terms = referrer.split('/');

    if (terms.length >= 3) {
      return terms[2];
    }

    return '';
  };

  _proto.isSupportMutationObserver = function isSupportMutationObserver() {
    return typeof MutationObserver != 'undefined';
  };

  _proto.isSupportIntersectionObserver = function isSupportIntersectionObserver() {
    return typeof IntersectionObserver != 'undefined';
  };

  _proto.isSupportLocalStorage = function isSupportLocalStorage() {
    var flag = true;

    try {
      window.localStorage.setItem('__localstorage_test', '1');
      window.localStorage.removeItem('__localstorage_test');
    } catch (e) {
      flag = false;
    }

    return flag;
  };

  _proto.detectBrowser = function detectBrowser() {
    return {
      supportMutationObserver: this.isSupportMutationObserver(),
      supportIntersectionObserver: this.isSupportIntersectionObserver(),
      supportLocalStorage: this.isSupportLocalStorage()
    };
  };

  return Detector;
}();

var _isChecked = null;

var isSupported = function isSupported(storage, forceCheck) {
  if (storage === void 0) {
    storage = window.localStorage;
  }

  if (forceCheck === void 0) {
    forceCheck = false;
  }

  if (_isChecked !== null && !forceCheck) {
    return _isChecked;
  }

  var supported = true;

  try {
    var key = '__inhouse:test';
    var val = 'abc';
    storage = storage || window.localStorage;
    storage.setItem(key, val);

    if (storage.getItem(key) !== val) {
      supported = false;
    }

    storage.removeItem(key);
  } catch (err) {
    console.error('localStorage unsupported');
    supported = false;
  }

  _isChecked = supported;
  return supported;
};

var prefix = '__inhouse:';
var local = {
  get: function get(key) {
    try {
      key = prefix + key;
      var value = window.localStorage.getItem(key);

      if (value === null) {
        return value;
      }

      var data = JSON.parse(value);

      if (!isObject(data)) {
        return data;
      }

      if (data.expires && Date.now() > data.expires) {
        local.remove(key);
        return null;
      }

      return data.value;
    } catch (error) {
      console.error(error);
    }

    return null;
  },
  getRaw: function getRaw(key) {
    try {
      key = prefix + key;
      var value = window.localStorage.getItem(key);

      if (value === null) {
        return value;
      }

      var data = JSON.parse(value);

      if (!isObject(data)) {
        return data;
      }

      return data.value;
    } catch (error) {
      console.error(error);
    }

    return null;
  },
  set: function set(key, value, maxAge) {
    try {
      key = prefix + key;
      var data = {
        value: value
      };
      maxAge && (data.expires = Date.now() + maxAge);
      window.localStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  remove: function remove(key) {
    try {
      key = prefix + key;
      window.localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
var session = {
  get: function get(key) {
    try {
      key = prefix + key;
      var value = window.sessionStorage.getItem(key);

      if (value === null) {
        return value;
      }

      var data = JSON.parse(value);

      if (!isObject(data)) {
        return data;
      }

      return data.value;
    } catch (error) {
      console.error(error);
    }

    return null;
  },
  set: function set(key, value) {
    try {
      key = prefix + key;
      var data = {
        value: value
      };
      window.sessionStorage.setItem(key, JSON.stringify(data));
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  },
  remove: function remove(key) {
    try {
      key = prefix + key;
      window.sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};
var storage = {
  isSupported: isSupported,
  local: local,
  session: session
};

/**
 * Base64 编码
 * @param str 待编码字符
 */
var encode = function encode(str) {
  // Reference: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
    return String.fromCharCode(Number("0x" + p1));
  }));
};

//https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
var supportsPushState = typeof window !== 'undefined' && /*#__PURE__*/function () {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }

  return window.history && typeof window.history.pushState === 'function';
}();

var polyfillNodeList = function polyfillNodeList() {
  if (window.NodeList && !NodeList.prototype.forEach) {
    // @ts-ignore
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  var history = window.history;
  var rawPushState = history.pushState;
  var replaceState = history.replaceState;

  function getMaybeUrl(c) {
    var __in_house = window.__in_house;
    var href = c;

    if (typeof __in_house !== 'undefined' && typeof c === 'string') {
      try {
        href = __in_house.get_spm_info(c);
      } catch (e) {
        console.log('GetMaybeUrl href error', e);
      }
    }

    return href;
  }

  function getNow() {
    return Date.now ? Date.now() : +new Date();
  }

  var latestClickUrl = {};
  if (!supportsPushState) return;

  window.history.pushState = function (a, b, c) {
    var href = getMaybeUrl(c);
    latestClickUrl = {
      url: c,
      href: href,
      time: getNow()
    };
    return rawPushState.call(this, a, b, href);
  };

  window.history.replaceState = function (a, b, c) {
    var href = '';

    if (latestClickUrl.url === c && latestClickUrl.time && getNow() - latestClickUrl.time < 10) {
      href = latestClickUrl.href || c;
    } else {
      href = getMaybeUrl(c);
    }

    latestClickUrl = {};
    return replaceState.call(this, a, b, href);
  };
};

var _listeners = [];

if (typeof EventTarget === 'function') {
  EventTarget.prototype.addCustomEventListener = function (type, listener, options) {
    _listeners.push({
      target: this,
      type: type,
      listener: listener
    });

    this.addEventListener(type, listener, options);
  };

  EventTarget.prototype.removeEventListeners = function (targetType) {
    for (var index = 0; index !== _listeners.length; index++) {
      var item = _listeners[index];
      var target = item.target,
          type = item.type,
          listener = item.listener;

      if (target == this && type == targetType) {
        this.removeEventListener(type, listener, false);
        this.removeEventListener(type, listener, true);
      }
    }
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire();
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var eventemitter3 = createCommonjsModule(function (module) {

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
{
  module.exports = EventEmitter;
}
});

var bridge = {
    default:commonjsGlobal,// for typescript
    call: function (method, args, cb) {
        var ret = '';
        if (typeof args == 'function') {
            cb = args;
            args = {};
        }
        var arg={data:args===undefined?null:args};
        if (typeof cb == 'function') {
            var cbName = 'dscb' + window.dscb++;
            window[cbName] = cb;
            arg['_dscbstub'] = cbName;
        }
        arg = JSON.stringify(arg);

        //if in webview that dsBridge provided, call!
        if(window._dsbridge){
           ret=  _dsbridge.call(method, arg);
        }else if(window._dswk||navigator.userAgent.indexOf("_dsbridge")!=-1){
           ret = prompt("_dsbridge=" + method, arg);
        }

       return  JSON.parse(ret||'{}').data
    },
    register: function (name, fun, asyn) {
        var q = asyn ? window._dsaf : window._dsf;
        if (!window._dsInit) {
            window._dsInit = true;
            //notify native that js apis register successfully on next event loop
            setTimeout(function () {
                bridge.call("_dsb.dsinit");
            }, 0);
        }
        if (typeof fun == "object") {
            q._obs[name] = fun;
        } else {
            q[name] = fun;
        }
    },
    registerAsyn: function (name, fun) {
        this.register(name, fun, true);
    },
    hasNativeMethod: function (name, type) {
        return this.call("_dsb.hasNativeMethod", {name: name, type:type||"all"});
    },
    disableJavascriptDialogBlock: function (disable) {
        this.call("_dsb.disableJavascriptDialogBlock", {
            disable: disable !== false
        });
    }
};

!function () {
    if (window._dsf) return;
    var ob = {
        _dsf: {
            _obs: {}
        },
        _dsaf: {
            _obs: {}
        },
        dscb: 0,
        dsBridge: bridge,
        close: function () {
            bridge.call("_dsb.closePage");
        },
        _handleMessageFromNative: function (info) {
            var arg = JSON.parse(info.data);
            var ret = {
                id: info.callbackId,
                complete: true
            };
            var f = this._dsf[info.method];
            var af = this._dsaf[info.method];
            var callSyn = function (f, ob) {
                ret.data = f.apply(ob, arg);
                bridge.call("_dsb.returnValue", ret);
            };
            var callAsyn = function (f, ob) {
                arg.push(function (data, complete) {
                    ret.data = data;
                    ret.complete = complete!==false;
                    bridge.call("_dsb.returnValue", ret);
                });
                f.apply(ob, arg);
            };
            if (f) {
                callSyn(f, this._dsf);
            } else if (af) {
                callAsyn(af, this._dsaf);
            } else {
                //with namespace
                var name = info.method.split('.');
                if (name.length<2) return;
                var method=name.pop();
                var namespace=name.join('.');
                var obs = this._dsf._obs;
                var ob = obs[namespace] || {};
                var m = ob[method];
                if (m && typeof m == "function") {
                    callSyn(m, ob);
                    return;
                }
                obs = this._dsaf._obs;
                ob = obs[namespace] || {};
                m = ob[method];
                if (m && typeof m == "function") {
                    callAsyn(m, ob);
                    return;
                }
            }
        }
    };
    for (var attr in ob) {
        window[attr] = ob[attr];
    }
    bridge.register("_hasJavascriptMethod", function (method, tag) {
         var name = method.split('.');
         if(name.length<2) {
           return !!(_dsf[name]||_dsaf[name])
         }else {
           // with namespace
           var method=name.pop();
           var namespace=name.join('.');
           var ob=_dsf._obs[namespace]||_dsaf._obs[namespace];
           return ob&&!!ob[method]
         }
    });
}();

var dsbridge = bridge;

function pageview(track) {
  var spmSet = new Set();

  var beforePage = function beforePage(page) {
    var _page$__tracker__;

    var spm = page === null || page === void 0 ? void 0 : (_page$__tracker__ = page.__tracker__) === null || _page$__tracker__ === void 0 ? void 0 : _page$__tracker__.value;

    if (spm && spmSet.has(spm)) {
      page.__tracker__.pageId = uidWithVersion();
    }
  };

  var afterPage = function afterPage(_data, page) {
    var _page$__tracker__2;

    var spm = page === null || page === void 0 ? void 0 : (_page$__tracker__2 = page.__tracker__) === null || _page$__tracker__2 === void 0 ? void 0 : _page$__tracker__2.value;
    if (!spm) return;

    if (!spmSet.has(spm)) {
      spmSet.add(spm);
    }
  };

  track.on(EventPageView, afterPage);
  track.on(BeforePageViewData, beforePage);
  track.on(ConfigChangeEvent, function () {
    track.getDataInfo();
  });
}

function time(tracker) {
  var config = {
    valid: false,
    serverTime: getNow(),
    usePerformance: false,
    now: getNow()
  };

  var now = function now() {
    return config.usePerformance ? performance.now() : Date.now();
  };

  function serverTimeAction(state, action) {
    if ((action === null || action === void 0 ? void 0 : action.type) === 'ServerTime') {
      var clientNow = now();
      var range = Math.ceil(clientNow - config.now);
      var timestamp = config.serverTime + range;
      return _extends({}, state, {
        timestamp: timestamp
      });
    }

    return state;
  }

  tracker.on(ConfigChangeEvent, function () {
    var serverTime = tracker.options.serverTime;
    if (!serverTime || config.valid) return;
    config.valid = true;
    config.serverTime = serverTime;

    if (typeof window.performance.now !== 'undefined') {
      config.usePerformance = true;
      config.now = window.performance.now();
    } else {
      config.usePerformance = false;
      config.now = getNow();
    }
  });
  tracker.on(ServerTimeInvalid, function () {
    config.valid = false;
  });
  tracker.registerAction(serverTimeAction);
}

function plugins(tracker) {
  pageview(tracker);
  time(tracker);
}

var noop = function noop() {};

var Request = /*#__PURE__*/function () {
  function Request(options) {
    if (options === void 0) {
      options = {};
    }

    this.useFetch = true;
    this.options = {
      timeout: 3000,
      useSendBeacon: false,
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    };
    this.set(options);
  }

  var _proto = Request.prototype;

  _proto.set = function set(options) {
    if (options === void 0) {
      options = {};
    }

    this.options = deepMerge(this.options, options);
  }
  /**
   * 发送 POST 请求
   * @param url URL
   * @param data 数据
   * @param options 配置项
   * @param callback 回调函数
   */
  ;

  _proto.post = function post(url, data, options, callback) {
    var _opts$beacon,
        _this = this;

    if (options === void 0) {
      options = {};
    }

    if (callback === void 0) {
      callback = noop;
    }

    var opts = deepMerge(this.options, options);
    var body = ''; // 如果是非 string 类型，帮忙 stringify 一下

    try {
      body = typeof data === 'string' ? data : JSON.stringify(data);
    } catch (error) {
      callback(error);
      return;
    } // 如果启用 sendBeacon 且浏览器支持


    var beaconUrl = isString(opts.beacon) ? opts.beacon : (_opts$beacon = opts.beacon) === null || _opts$beacon === void 0 ? void 0 : _opts$beacon.url;

    if (beaconUrl && isFunction(window.navigator.sendBeacon)) {
      var cb = function cb(err, data) {
        if (err) {
          // using xhr retry to send data
          return _this.fetchOrXhr(url, body, opts, callback);
        }

        return isFunction(callback) ? callback(err, data) : callback;
      };

      this._sendBeacon(beaconUrl, body, opts, cb);

      return;
    }

    this.fetchOrXhr(url, body, opts, callback);
  };

  _proto.fetchOrXhr = function fetchOrXhr(url, body, opts, callback) {
    if (opts === void 0) {
      opts = {};
    }

    if (callback === void 0) {
      callback = noop;
    }

    // if (this.useFetch) {
    //   const cb = (...args: any[]) => {
    //     if (args[0]) {
    //       this.useFetch = false
    //     }
    //     return isFunction(callback) ? callback.apply(this, args as any) : null
    //   }
    //   this.fetch(url, body, opts, cb)
    // } else {
    this.sendWithXhr(url, body, opts, callback); // }
  };

  _proto.sendWithXhr = function sendWithXhr(url, body, options, callback) {
    if (options === void 0) {
      options = {};
    }

    if (callback === void 0) {
      callback = noop;
    }

    var headers = isObject(options.headers) ? options.headers : {}; // 发起 XMLHttpRequest 请求

    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true); // 设置 HTTP Headers

    Object.keys(headers).forEach(function (key) {
      headers[key] && xhr.setRequestHeader(key, headers[key]);
    });
    xhr.withCredentials = !!options.withCredentials;
    xhr.timeout = options.timeout && options.timeout > 0 ? options.timeout : 30000;
    xhr.addEventListener('load', function () {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            callback(null, JSON.parse(xhr.responseText));
          } catch (error) {
            callback(error, xhr.responseText);
          }
        } else {
          callback(new Error(xhr.statusText));
        }
      }
    });
    xhr.addEventListener('abort', function () {
      callback(new Error("Request abort"));
    });

    xhr.ontimeout = function () {
      callback(new Error("Request timeout"));
    };

    xhr.addEventListener('error', function () {
      callback(new Error("An error occurred"));
    });
    xhr.send(body);
  }
  /**
   * 使用 sendBeacon 发送数据
   * @NOTE: 注意，sendBeacon 不支持自定义 HTTP Headers
   * Ref: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon
   * @param url URL
   * @param data 数据
   * @param options 配置项
   * @param callback 回调函数
   */
  ;

  _proto._sendBeacon = function _sendBeacon(url, data, options, callback) {
    try {
      var headers = options.headers || {};
      var blob = new Blob([data], {
        type: ApplicationJson
      });
      var platform = headers.platform || headers['X-Platform'] || 'desktop';
      var corsUrl = this.normalizeUrl(url, platform);

      if (window.navigator.sendBeacon) {
        var result = window.navigator.sendBeacon(corsUrl, blob);
        callback(result ? null : new Error('Request failed in sendBeacon()'));
      } else {
        callback(new Error('Not support sendBeacon()'));
      }
    } catch (error) {
      callback(error);
    }
  };

  _proto.normalizeUrl = function normalizeUrl(url, platform) {
    var urlArr = url.split('?');
    urlArr[1] = ["platform=" + platform, urlArr[1]].filter(Boolean).join('&');
    return urlArr.join('?');
  };

  _proto.fetch = function fetch(url, data, options, callback) {
    if (callback === void 0) {
      callback = noop;
    }

    try {
      var _options$headers;

      window.fetch(this.normalizeUrl(url, ((_options$headers = options.headers) === null || _options$headers === void 0 ? void 0 : _options$headers.platform) || 'desktop'), {
        keepalive: true,
        headers: {
          'content-type': ApplicationJson
        },
        body: new Blob([data], {
          type: ApplicationJson
        }),
        method: 'POST',
        credentials: 'omit'
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data.success) {
          callback(null);
        } else {
          var _data$error;

          callback(new Error(((_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.message) || 'api error'));
        }
      })["catch"](function (e) {
        return callback(e);
      });
    } catch (e) {
      callback(e);
    }
  };

  return Request;
}();

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var localforage = createCommonjsModule(function (module, exports) {
/*!
    localForage -- Offline Storage, Improved
    Version 1.9.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
},{}],2:[function(_dereq_,module,exports){
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
},{"2":2}],4:[function(_dereq_,module,exports){

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb || !idb.open) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support
        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
        // Safari 10.1 shipped with fetch, we can use that to detect it.
        // Note: this creates issues with `window.fetch` polyfills and
        // overrides; see:
        // https://github.com/localForage/localForage/issues/856
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            resolve(openreq.result);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback returns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = req.onblocked = function (err) {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(err);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});
});

var logger = /*#__PURE__*/new Logger();
localforage.config({
  name: 'klk-inhouse-tracker',
  storeName: 'klk-inhouse-tracker',
  description: ''
});
var getDbItem = function getDbItem(key) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(localforage.getItem(key));
    }, function (err) {
      logger.warn('localForage getItem error', JSON.stringify(err));
      return null;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};
var setDbItem = function setDbItem(key, value) {
  try {
    var _temp2 = _catch(function () {
      return Promise.resolve(localforage.setItem(key, value)).then(function () {});
    }, function (err) {
      logger.warn('localForage setItem error', JSON.stringify(err));
    });

    return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
var removeDbItem = function removeDbItem(key) {
  try {
    var _temp4 = _catch(function () {
      return Promise.resolve(localforage.removeItem(key)).then(function () {});
    }, function (err) {
      logger.warn('localForage removeItem error', JSON.stringify(err));
    });

    return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {}) : void 0);
  } catch (e) {
    return Promise.reject(e);
  }
};
var getDbKeys = function getDbKeys() {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(localforage.keys());
    }, function (err) {
      logger.warn('localForage getKeys error', JSON.stringify(err));
      return [];
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var TrackerCache = /*#__PURE__*/function () {
  function TrackerCache() {}

  TrackerCache.setItem = function setItem(key, value, maxAge) {
    storage.local.set(key, value, maxAge);
  };

  TrackerCache.getItem = function getItem(key) {
    return storage.local.get(key);
  };

  TrackerCache.removeItem = function removeItem(key) {
    storage.local.remove(key);
  };

  TrackerCache.setItemAsync = function setItemAsync(key, value) {
    try {
      return Promise.resolve(setDbItem(key, value)).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  TrackerCache.getItemAsync = function getItemAsync() {
    try {
      return Promise.resolve(getDbKeys()).then(function (keys) {
        var _exit = false;

        var _temp4 = function () {
          if (keys.length) {
            var key = keys[0];
            return Promise.resolve(getDbItem(key)).then(function (data) {
              var _exit2 = false;

              function _temp3(_result2) {
                if (_exit2) return _result2;
                var _key$value$length = {
                  key: key,
                  value: data,
                  length: keys.length
                };
                _exit = true;
                return _key$value$length;
              }

              var _temp2 = function () {
                if (!data) {
                  return Promise.resolve(removeDbItem(key)).then(function () {
                    var _temp = null;
                    _exit = true;
                    return _temp;
                  });
                }
              }();

              return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
            });
          }
        }();

        return _temp4 && _temp4.then ? _temp4.then(function (_result) {
          return _exit ? _result : null;
        }) : _exit ? _temp4 : null;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  TrackerCache.removeItemAsync = function removeItemAsync(key) {
    try {
      return Promise.resolve(removeDbItem(key)).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return TrackerCache;
}();

var RequestQueue = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(RequestQueue, _EventEmitter);

  function RequestQueue(options, instance) {
    var _this;

    _this = _EventEmitter.call(this) || this;
    _this._queue = [];
    _this.haveChance = true;
    _this.queueingSet = new Set();
    _this.concurrent = 0;
    _this.serverFailCount = 0;
    _this.innerState = new Map();
    _this.debug = false;
    _this.options = {
      url: '',
      size: 5,
      retry: 5,
      headers: {},
      platform: '',
      deviceId: '',
      timeout: 15000,
      concurrent: 3,
      throttleTime: 16,
      maxQueueSize: 50,
      localCacheKey: 'inhouse:RequestQueue:local'
    };

    _this.setOptions(options);

    _this._request = new Request({});
    _this._logger = new Logger({
      name: 'RequestQueue',
      debug: options === null || options === void 0 ? void 0 : options.debug
    });
    _this._instance = instance;
    _this.debug = Boolean(options === null || options === void 0 ? void 0 : options.debug);

    _this.bindEvent();

    return _this;
  }

  var _proto = RequestQueue.prototype;

  _proto.emit = function emit(event) {
    var _this$_instance, _EventEmitter$prototy;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_this$_instance = this._instance).emit.apply(_this$_instance, [event].concat(args));

    return (_EventEmitter$prototy = _EventEmitter.prototype.emit).call.apply(_EventEmitter$prototy, [this, event].concat(args));
  };

  _proto.bindEvent = function bindEvent() {
    var _this2 = this;

    this.on('request:before', function () {
      _this2.concurrent++;
    });
    this.on('request:success', function () {
      var _this2$options$size = _this2.options.size,
          size = _this2$options$size === void 0 ? 5 : _this2$options$size;
      _this2.serverFailCount = 0;
      _this2.options.size = size < 10 ? size + 1 : 5;
    });
    this.on('request:fail', function () {
      var _this2$options$size2 = _this2.options.size,
          size = _this2$options$size2 === void 0 ? 5 : _this2$options$size2;
      _this2.serverFailCount++;
      _this2.options.size = size > 2 ? size - 2 : 1;
    });
    this.on('request:finish', function () {
      _this2.concurrent--;
      var serverFailCount = _this2.serverFailCount;

      if (serverFailCount >= 2) {
        _this2.options.concurrent = 1;
      } else {
        _this2.options.concurrent = 4;
      }

      _this2.getDataFromCache();
    });
    this.on('queue:empty', function () {
      _this2.getDataFromCache();
    });
    this.on('page:unload', function () {
      _this2.pageWillUnload();
    });
  };

  _proto.getDataFromCache = function getDataFromCache() {
    var _this4 = this;

    var _this3 = this;

    // 避免同步读取影响页面渲染
    if (!this.isOnline()) return;
    var innerState = this.innerState,
        localCacheKey = this.options.localCacheKey;
    var key = localCacheKey || 'hasLocalData';

    if (!innerState.has(key)) {
      this.processNextTick(function () {
        var payloads = TrackerCache.getItem(localCacheKey);

        if (payloads) {
          _this3.sendData(payloads);

          TrackerCache.removeItem(localCacheKey);
        } else {
          innerState.set(key, false);
        }
      });
    }

    if (this.serverFailCount > 7) return;
    var processingKey = 'isItemProcessing';
    if (innerState.has(processingKey)) return;
    innerState.set(processingKey, true);
    var deTimeout = this.concurrent > 1 ? 1 : 0.2;
    var timeout = this.serverFailCount < 10 ? 1000 * (this.serverFailCount || deTimeout) : 10000;
    clearTimeout(this.timeId);
    this.timeId = this.processNextTick(function () {
      try {
        _this4.getItems();

        innerState["delete"](processingKey);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    }, timeout);
  };

  _proto.processNextTick = function processNextTick(cb, timeout) {
    var _this5 = this;

    if (timeout === void 0) {
      timeout = 500;
    }

    return setTimeout(function () {
      cb.call(_this5);
    }, timeout);
  };

  _proto.getItems = function getItems() {
    try {
      var _this7 = this;

      var _queue = _this7._queue;
      if (!_this7.haveChanceFlag()) return Promise.resolve();

      if (_queue.length > 0) {
        _this7.throttleRequest();

        return Promise.resolve();
      }

      return Promise.resolve(TrackerCache.getItemAsync().then(function (res) {
        try {
          var _temp2 = function () {
            if (res && res.key && res.value) {
              var key = res.key,
                  value = res.value;
              var payloads = Array.isArray(value) ? value : [value];
              return Promise.resolve(TrackerCache.removeItemAsync(key)).then(function () {
                _this7.pushQueue(payloads);
              });
            }
          }();

          return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      })["catch"](function (e) {
        _this7._logger.error(e);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setOptions = function setOptions(configs) {
    if (!isObject(configs)) return;
    var filterConfig = transformObj(configs || {});
    var options = this.options;
    this.options = _extends({}, options, filterConfig);
  };

  _proto.isOnline = function isOnline() {
    return navigator && navigator.onLine !== undefined ? navigator.onLine : true;
  };

  _proto.haveChanceFlag = function haveChanceFlag() {
    var _this$_instance2, _this$_instance2$opti;

    var haveChance = this.haveChance,
        concurrent = this.concurrent,
        maxConcurrent = this.options.concurrent;
    maxConcurrent = maxConcurrent || 5;

    if (concurrent > maxConcurrent) {
      this.concurrent--;
    }

    var hasUrl = this.options.url || ((_this$_instance2 = this._instance) === null || _this$_instance2 === void 0 ? void 0 : (_this$_instance2$opti = _this$_instance2.options) === null || _this$_instance2$opti === void 0 ? void 0 : _this$_instance2$opti.url) || this.useBeacon();
    var online = this.isOnline();
    return haveChance && concurrent < maxConcurrent && online && hasUrl;
  };

  _proto.uuid = function uuid() {
    return String(Date.now() + Math.random());
  };

  _proto.pushQueue = function pushQueue(logs) {
    var _this8 = this;

    var queue = this._queue,
        queueingSet = this.queueingSet,
        concurrent = this.concurrent,
        serverFailCount = this.serverFailCount,
        _this$options = this.options,
        maxQueueSize = _this$options.maxQueueSize,
        _this$options$concurr = _this$options.concurrent,
        maxConcurrent = _this$options$concurr === void 0 ? 5 : _this$options$concurr;
    var haveChance = this.haveChanceFlag();

    if (this._queue.length > maxQueueSize || !haveChance) {
      if (concurrent >= maxConcurrent && serverFailCount < 1 && this._queue.length <= maxQueueSize / 2) {
        this._queue = queue.concat(logs).filter(Boolean);
        return;
      }

      if (concurrent < 1 && this._queue.length > 0 && serverFailCount > 1) {
        this.serverFailCount--;
      } // cache data


      queueingSet.add(logs);

      this._logger.info('Cache to indexdb', logs);

      this.setLogs2Idb(this.uuid(), logs).then(function () {
        queueingSet["delete"](logs);
      })["catch"](function (e) {
        _this8._logger.error(e);
      });
    } else {
      this._queue = queue.concat(logs).filter(Boolean);
    }

    this.throttleRequest();
  };

  _proto.setLogs2Idb = function setLogs2Idb(key, logs) {
    var payloads = [];
    var _this$options$retry = this.options.retry,
        retry = _this$options$retry === void 0 ? 5 : _this$options$retry;
    logs.forEach(function (i) {
      var rty = (i.rty | 0) + 1;

      if (rty <= retry) {
        payloads.push(_extends({}, i, {
          rty: rty
        }));
      }
    });
    return payloads.length ? TrackerCache.setItemAsync(key, payloads) : Promise.resolve();
  }
  /**
   * 发送数据接口
   * @param logs MixPayload
   */
  ;

  _proto.sendData = function sendData(logs) {
    this.pushQueue(Array.isArray(logs) ? logs : [logs]);
  };

  _proto.pageWillUnload = function pageWillUnload() {
    var payloads = this.getPayloads();
    var localCacheKey = this.options.localCacheKey;

    this._logger.info('cache to local', payloads);

    if (payloads.length && localCacheKey) {
      var localData = TrackerCache.getItem(localCacheKey);
      localData = Array.isArray(localData) ? localData : [];
      localData = localData.concat(payloads).slice(0, 100);
      TrackerCache.setItem(localCacheKey, localData);
      this.emptyCurrentQueue();
    }
  };

  _proto.emptyCurrentQueue = function emptyCurrentQueue() {
    this._queue.length = 0;
    this.queueingSet.clear();
  };

  _proto.getPayloads = function getPayloads() {
    var queue = this._queue,
        queueingSet = this.queueingSet;
    var payloads = queue.slice();
    var queueingArr = Array.from(queueingSet).filter(Boolean).reduce(function (a, b) {
      return a.concat(b);
    }, []);
    payloads = payloads.concat(queueingArr);
    return payloads;
  };

  _proto.flushQueue = function flushQueue() {
    this.throttleRequest();
  };

  _proto.hasListenerCount = function hasListenerCount(keys) {
    var _this9 = this;

    return keys.some(function (k) {
      var _this9$_instance;

      return k && ((_this9$_instance = _this9._instance) === null || _this9$_instance === void 0 ? void 0 : _this9$_instance.listenerCount(k));
    });
  };

  _proto.throttleRequest = function throttleRequest() {
    var _this10 = this;

    var queue = this._queue,
        queueingSet = this.queueingSet,
        size = this.options.size;
    var haveChance = this.haveChanceFlag();
    if (!haveChance) return;

    if (!queue.length) {
      this.emit('queue:empty');
      return;
    }

    var payloads = queue.splice(0, size);
    queueingSet.add(payloads);
    this.emit('request:before', {
      payloads: payloads
    });
    this.send(payloads, function (error, resp) {
      var callbackData = {
        payloads: payloads,
        error: error,
        raw: payloads,
        success: !error
      };
      var decodeData;

      var decodePayload = function decodePayload(payloads) {
        return payloads.map(function (i) {
          var msg = i.msg;

          try {
            msg = JSON.parse(atob(i.msg));
          } catch (_e) {}

          return _extends({}, i, {
            msg: msg
          });
        });
      };

      if (_this10.hasListenerCount([RequestSuccess, RequestFinish, RequestFail])) {
        decodeData = decodePayload(payloads);
        callbackData.payloads = decodeData;
      }

      if (!error) {
        queueingSet["delete"](payloads);

        _this10.emit(RequestSuccess, callbackData);

        try {
          if (_this10.debug) {
            _this10._logger.info('success data: ', decodeData || decodePayload(payloads));
          }
        } catch (e) {
          _this10._logger.error(e);
        }

        if (isObject(resp) && !resp.success) {
          _this10._logger.warn('server response: ', resp);
        }
      } else {
        _this10.emit(RequestFail, callbackData);

        _this10.setLogs2Idb(_this10.uuid(), payloads).then(function () {
          queueingSet["delete"](payloads);
        });

        _this10._logger.warn('request Error: ', error);
      }

      _this10.emit(RequestFinish, callbackData);
    });
  };

  _proto.useBeacon = function useBeacon() {
    var _this$_instance3;

    var useSendBeacon = (_this$_instance3 = this._instance) === null || _this$_instance3 === void 0 ? void 0 : _this$_instance3.options.beacon;
    var reqBeacon = this.options.beacon;
    return useSendBeacon || reqBeacon;
  };

  _proto.send = function send(payloads, callback) {
    var _this$_instance4,
        _this$_instance5,
        _this$_instance5$opti,
        _this11 = this;

    if (callback === void 0) {
      callback = function callback() {};
    }

    var _this$options2 = this.options,
        timeout = _this$options2.timeout,
        headers = _this$options2.headers,
        platform = _this$options2.platform,
        deviceId = _this$options2.deviceId;

    if (isSearchBot() || !payloads) {
      callback();
      return;
    }

    if (!deviceId) {
      this._logger.warn('Lack Of deviceId', deviceId);
    }

    var xDeviceId = deviceId || ((_this$_instance4 = this._instance) === null || _this$_instance4 === void 0 ? void 0 : _this$_instance4.getDeviceId());

    if (!xDeviceId) {
      var payload = Array.isArray(payloads) ? payloads[0] : payloads;
      xDeviceId = payload && payload.deviceId || '';
      this.options.deviceId = xDeviceId;
    }

    var headerOptions = deepMerge(headers, {
      'X-Platform': platform || 'desktop',
      'X-DeviceId': xDeviceId
    });
    var url = this.options.url || ((_this$_instance5 = this._instance) === null || _this$_instance5 === void 0 ? void 0 : (_this$_instance5$opti = _this$_instance5.options) === null || _this$_instance5$opti === void 0 ? void 0 : _this$_instance5$opti.url);
    var useSendBeacon = this.useBeacon();

    if (!url && !useSendBeacon) {
      callback(new Error('Url not be empty'));
      return;
    }

    this.emit('request:beforeSend', {
      headers: headerOptions,
      payloads: payloads
    });

    this._request.post(url, json2string({
      logs: payloads
    }), {
      beacon: useSendBeacon,
      useSendBeacon: !!useSendBeacon,
      timeout: timeout,
      headers: headerOptions
    }, function (error, resp) {
      callback(error, resp);

      if (error) {
        _this11._logger.error('inhouse tracker xhr error', error);
      }
    });
  };

  return RequestQueue;
}(eventemitter3);

var getKlkCommonFunc = function getKlkCommonFunc(k, args) {
  var klk_common = window.klk_common;
  var session = klk_common && klk_common.session;
  return typeof session !== 'undefined' && isFunction(session[k]) ? session[k].apply(session, args) : null;
};

var updateIhtSession = function updateIhtSession() {
  return getKlkCommonFunc('updateIhtSession');
};
var getSessionId = function getSessionId() {
  return getKlkCommonFunc('getCurrentSession') || {};
};

polyfillNodeList();
var ClickEmpty = {
  clickId: '-1',
  clickSpm: 'unknown',
  timestamp: -1
};
var Tracker = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(Tracker, _EventEmitter);

  function Tracker(options) {
    var _performance$timing;

    var _this;

    if (options === void 0) {
      options = {};
    }

    _this = _EventEmitter.call(this) || this;
    _this.constants = _extends({}, Constants); // 默认配置项

    _this.options = {
      url: '',
      timeout: 15000,
      throttleTime: 400,
      autoPageView: true,
      props: {
        pageId: '',
        deviceId: '',
        keplerId: '',
        distinctId: '',
        experiments: [],
        platform: '',
        siteName: '',
        siteLanguage: '',
        siteCurrency: ''
      },
      sprops: {},
      isDebugMode: false,
      logDebug: false,
      concurrent: 4,
      batchSize: 5,
      exposureDuration: 500,
      exposureRate: 0.8,
      enableProxyClick: true
    };
    _this.innerState = {};
    _this._callbackQueue = [];
    _this._isReady = false;
    _this.version = config.version; // 埋点属性配置

    _this._attrs = {
      page: 'data-spm-page',
      module: 'data-spm-module',
      item: 'data-spm-item',
      virtualItem: 'data-spm-virtual-item'
    }; // 追踪信息

    _this._from = {
      clickId: '-1',
      clickSpm: 'unknown',
      timestamp: -1
    };
    _this.localConfig = {
      lastRef: '',
      unloadT: 0,
      initT: getNow(),
      lastPv: '',
      currentPv: '',
      pvCount: 0,
      from: {}
    };
    _this.latestFrom = {};
    _this.firstPv = ''; // 追踪节点

    _this.$pages = [];
    _this.$modules = [];
    _this.$items = [];
    _this.$virtualItems = [];
    _this.concurrent = 0;
    _this.pageIsUnload = false;
    _this.isIe = false;
    _this.isBot = false;
    _this.isDebug = false;
    _this.actions = [];
    _this.actionQueue = [];
    /**
     * @internal
     */

    _this._disableConfig = {
      module: []
    };
    _this.isIe = isIe();
    _this.isBot = isSearchBot(); // if (this.isBot) return;

    var debug = storage.local.get('debug');
    _this.isDebug = Boolean(debug);
    _this.options = deepMerge(_this.options, options, {
      isDebugMode: Boolean(debug)
    });
    _this._props = _this.options.props || {};
    _this._sprops = _this.options.sprops || {};
    _this._logger = new Logger({
      debug: debug
    });
    _this._detector = new Detector();
    _this._requestQueue = new RequestQueue({
      debug: Boolean(debug)
    }, _assertThisInitialized(_this));
    _this.innerState._navTime = ((_performance$timing = performance.timing) === null || _performance$timing === void 0 ? void 0 : _performance$timing.navigationStart) || getNow();

    _this.readLocalConfig();

    _this.initMutationAndInter();

    _this.initEvents();

    _this.bindNativeEvent();

    _this.bindFromEvent();

    plugins(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Add track page
   * @param page
   */


  var _proto = Tracker.prototype;

  _proto.addPage = function addPage(_page) {
    var pages = this.$pages;
    var pageAttr = this._attrs.page;
    var page = _page;

    if (_page.hasAttribute(pageAttr) && !pages.includes(page)) {
      pages.push(page);
    }

    return pages;
  }
  /**
   * 禁用 `page` | `module` | `item` 事件上报
   *
   * @example 禁用所有module 的上报
   * ```typescripts
   * tracker.disable({
   *  type: 'module',
   *  rules: () => return true
   * })
   * ```
   * @example
   * ```typescripts
   * tracker.disable({
   *  type: 'module',
   *  rules: [() => {
   *    const current = new Date()
   *     const date = current.getDate()
   *     const year = current.getFullYear()
   *     const month = current.getMonth()
   *     if (year !== 2023) return false
   *     // 7.7
   *     if (month === 6 && date === 7) return true
   *     return false
   *  }]
   * })
   * ```
   *
   * @example 禁用/test/页面module上报
   * ```typescripts
   * tracker.disable({
   *  type: 'module',
   *  rules: /test/
   * })
   * ```
   * @param config
   */
  ;

  _proto.disable = function disable(config) {
    var type = config.type,
        rules = config.rules;

    var _rules = Array.isArray(rules) ? rules : [rules];

    var _disableConfig = this._disableConfig;
    var mod = _disableConfig[type];

    if (mod) {
      _rules.forEach(function (rule) {
        if (!mod.includes(rule)) {
          mod.push(rule);
        }
      });
    }
  };

  _proto.isModuleDisabled = function isModuleDisabled() {
    var _disableConfig = this._disableConfig;
    var module = _disableConfig.module;
    return module.some(function (rule) {
      if (typeof rule === 'function') {
        return rule();
      }

      return rule.test(window.location.href);
    });
  };

  _proto.callActions = function callActions(action) {
    var _this2 = this;

    var actions = this.actions;
    var state = {};
    actions.forEach(function (fn) {
      var newState = fn.call(_this2, state, action);
      state = Object.assign(state, newState);
    });
    return state;
  };

  _proto.registerAction = function registerAction(action) {
    if (!this.actions.includes(action)) this.actions.push(action);
  };

  _proto.getTimestamp = function getTimestamp() {
    // const state = this.callActions<{ timestamp: number }>({
    //   type: 'ServerTime',
    // })
    return getNow();
  };

  _proto.close = function close() {
    this.emit('close');
  };

  _proto.readLocalConfig = function readLocalConfig() {
    var localData = storage.local.get(LocalConfigKey) || {};
    this.localConfig = _extends({}, this.localConfig, localData);
  };

  _proto.bindFromEvent = function bindFromEvent() {
    this.off('fromChange');
  };

  _proto.initMutationAndInter = function initMutationAndInter() {
    if (this.isIe || this.isBot) return;
    this._mobserver = this.createMutationObserver();
    if (this.isModuleDisabled()) return;
    this._iobserver = this.createIntersectionObserver();
  };

  _proto.bindNativeEvent = function bindNativeEvent() {
    var _this3 = this;

    window.addEventListener('error', function (ev) {
      _this3._logger.info({
        eMessage: ev.message,
        eFile: ev.filename,
        eLine: String(ev.lineno),
        eCol: String(ev.colno)
      });
    });
    if (this.isBot) return;
    window.addEventListener('online', function () {
      _this3._requestQueue.flushQueue();
    });
    window.addEventListener('beforeunload', function () {
      _this3.pageIsUnload = true;

      _this3._requestQueue.flushQueue();
    });
    window.addEventListener('unload', function () {
      _this3._logger.info('unload:unload', getNow());

      _this3.pageMayUnload();
    });
    document.addEventListener('click', function (ev) {
      if (_this3.isBot) return;
      if (!_this3.options.enableProxyClick) return;
      var target = ev.target || ev.currentTarget;

      if (target) {
        // @ts-ignore
        if (target.clicked) {
          // @ts-ignore
          target.clicked = false;
        }
      }
    }, false);
    document.addEventListener('click', function (ev) {
      if (_this3.isBot || !_this3.options.enableProxyClick) return;
      var target = ev.target || ev.currentTarget; // @ts-ignore

      if (target && !target.clicked) {
        _this3.proxyClickInfo(target, ev);
      }
    }, true);
    document.addEventListener('mousedown', function (ev) {
      if (_this3.isBot || !_this3.options.enableProxyClick) return;
      var target = ev.target || ev.currentTarget;

      if (target) {
        _this3.proxyClickInfo(target, ev);
      }
    }, true);
  };

  _proto.proxyClickInfo = function proxyClickInfo(target, _ev) {
    var _aItem$getAttribute;

    var _this$_attrs = this._attrs,
        item = _this$_attrs.item,
        virtualItem = _this$_attrs.virtualItem,
        module = _this$_attrs.module,
        page = _this$_attrs.page;
    var latestItem = findLatestElement(target, function (ele) {
      var _ele$hasAttribute, _ele$hasAttribute2, _ele$hasAttribute3;

      if (ele !== null && ele !== void 0 && (_ele$hasAttribute = ele.hasAttribute) !== null && _ele$hasAttribute !== void 0 && _ele$hasAttribute.call(ele, item) || ele !== null && ele !== void 0 && (_ele$hasAttribute2 = ele.hasAttribute) !== null && _ele$hasAttribute2 !== void 0 && _ele$hasAttribute2.call(ele, virtualItem)) {
        return 1;
      }

      if (ele !== null && ele !== void 0 && (_ele$hasAttribute3 = ele.hasAttribute) !== null && _ele$hasAttribute3 !== void 0 && _ele$hasAttribute3.call(ele, module)) {
        return -1;
      }

      return 0;
    });
    if (!latestItem) return;
    var latestA = findLatestElement(target, function (ele) {
      var _ele$hasAttribute4;

      if (ele !== null && ele !== void 0 && ele.hasAttribute && (ele === null || ele === void 0 ? void 0 : ele.tagName) === 'A') {
        var _href = ele.getAttribute('href') || '';

        if (isSpecialLink(_href)) return 0;
        return 1;
      }

      if (ele !== null && ele !== void 0 && (_ele$hasAttribute4 = ele.hasAttribute) !== null && _ele$hasAttribute4 !== void 0 && _ele$hasAttribute4.call(ele, page)) {
        return -1;
      }

      return 0;
    });
    var aItem = latestItem.tagName === 'A' ? latestItem : latestA;
    var href = aItem === null || aItem === void 0 ? void 0 : (_aItem$getAttribute = aItem.getAttribute) === null || _aItem$getAttribute === void 0 ? void 0 : _aItem$getAttribute.call(aItem, 'href');
    var spmItem = latestItem;
    var spm = this.collectSpm(spmItem);

    if (!spm.code || !spm.page || !spm.module || !spm.item) {
      this._logger.warn('Not found spm info', spm);

      return;
    }

    var __tracker = spmItem.__virtualTracker__ || spmItem.__tracker__ || {
      clickId: ''
    };

    var clickId = this.getClickId().slice(-10);
    var clickSpm = spm.code;

    if (href && aItem) {
      __tracker.clickId = clickId;
      var url = joinClickSpmToUrl(href, clickSpm || '', clickId);

      if (!isSpecialLink(href)) {
        aItem === null || aItem === void 0 ? void 0 : aItem.setAttribute('href', url);
      } // @ts-ignore


      target.clicked = true;
      this.latestFrom = {
        targeSrc: href,
        timestamp: getNow(),
        clickId: clickId,
        clickSpm: clickSpm
      };
    } else {
      __tracker.clickId = clickId;
      this.latestFrom = {
        timestamp: getNow(),
        clickId: clickId,
        clickSpm: clickSpm
      };
    }
  } // private checkClickEvent(aItem: Element,
  //   // spmItem: Element,
  //   e: Event) {
  //   const href = aItem.getAttribute?.('href') || ''
  //   if (aItem?.tagName === 'A' && href && !href.startsWith('javascript')) {
  //     e.stopImmediatePropagation()
  //     // this.track('action', spmItem)
  //   }
  // }
  ;

  _proto.pageMayUnload = function pageMayUnload() {
    this._requestQueue.emit('page:unload');

    this.setLocalConfig({
      unloadT: getNow(),
      lastPv: this.firstPv || '',
      lastRef: window.location.href,
      pvCount: 0
    });
  };

  _proto.getLastRef = function getLastRef() {
    var lastRef = this.localConfig.lastRef;
    return lastRef || '';
  };

  _proto.setLocalConfig = function setLocalConfig(Options) {
    if (Options === void 0) {
      Options = {};
    }

    var localData = storage.local.get(LocalConfigKey) || {};
    this.localConfig = _extends({}, this.localConfig, localData, Options);
    storage.local.set(LocalConfigKey, this.localConfig);
  };

  _proto.initEvents = function initEvents() {
    var _this4 = this;

    this.on(EventPageView, function (data) {
      var _data$eventCommon2;

      if (_this4.localConfig.pvCount < 1) {
        var _data$eventCommon;

        _this4.firstPv = (data === null || data === void 0 ? void 0 : (_data$eventCommon = data.eventCommon) === null || _data$eventCommon === void 0 ? void 0 : _data$eventCommon.spm) || '';
      }

      _this4.localConfig = _extends({}, _this4.localConfig, {
        currentPv: data === null || data === void 0 ? void 0 : (_data$eventCommon2 = data.eventCommon) === null || _data$eventCommon2 === void 0 ? void 0 : _data$eventCommon2.spm,
        pvCount: _this4.localConfig.pvCount + 1
      });
      updateIhtSession();
    });
    this.on(EventAction, function () {
      updateIhtSession();
    });
    this.on(EventExposure, function () {
      updateIhtSession();
    });
    this.on(InhouseInitReady, function () {
      _this4._isReady = true;
      var callbackQueue = _this4._callbackQueue;

      while (callbackQueue.length) {
        var args = callbackQueue.shift();

        if (args) {
          _this4.track.apply(_this4, args);
        }
      }
    });
    this.on(InhouseInit, function () {
      _this4._requestQueue.emit('request:success');
    });
  };

  _proto.setAppTrackIds = function setAppTrackIds() {
    if (isInApp()) {
      var url = window.location.href;

      var getData = function getData(key) {
        return getQueryParam(url, key) || getFromCookie(key);
      };

      var distinctId = getData('app_track_distinct_id');
      var deviceId = getData('app_track_device_id');

      var props = _extends({}, distinctId ? {
        distinctId: distinctId
      } : {}, deviceId ? {
        deviceId: deviceId,
        keplerId: deviceId
      } : {});

      this.setProps(_extends({}, props));

      if (deviceId) {
        this._requestQueue.setOptions({
          deviceId: deviceId || this.options.props.deviceId || '',
          platform: this._props.platform
        });
      }
    }
  };

  _proto.setConfig = function setConfig(options) {
    this.options = deepMerge(this.options, options);
    this.setProps(this.options.props);
    this.emit(ConfigChangeEvent, this);
  }
  /**
   * alias of setConfig
   * @param options
   */
  ;

  _proto.config = function config(options) {
    if (options === void 0) {
      options = {};
    }

    this.setConfig(options || {});
  };

  _proto.updateReferrerInSpa = function updateReferrerInSpa() {
    var innerState = this.innerState;
    innerState['lastReferer'] = innerState['referer'] || document.referrer;
    innerState['referer'] = window.location.href;
  };

  _proto.getClickInfo = function getClickInfo() {
    return _extends({}, this._from);
  }
  /**
   * 初始化
   * @param options 配置项
   */
  ;

  _proto.init = function init(options) {
    var _this5 = this;

    if (options === void 0) {
      options = {};
    }

    if (this.isBot) return;
    this.setConfig(options);
    this._props = this.options.props || {};
    this.setAppTrackIds();
    this.updateReferrerInSpa();
    this._sprops = this.options.sprops || {};

    this._requestQueue.setOptions(_extends({}, this.options, this.options.props, {
      url: this.options.url,
      platform: this._props.platform
    }, this.options.request));

    this.onDomReady(function () {
      _this5._from = _this5.collectFromInfo();
      _this5.$pages = _this5.collectPageNodes();
      _this5.$items = _this5.collectItemNodes();
      _this5.$virtualItems = _this5.collectVirtualItemNodes();
      _this5.$modules = _this5.collectModuleNodes(); // 自动上报 pageview 事件

      if (_this5.options.autoPageView) {
        _this5.$pages.forEach(function ($page) {
          var _$page$__tracker__;

          if (((_$page$__tracker__ = $page.__tracker__) === null || _$page$__tracker__ === void 0 ? void 0 : _$page$__tracker__.trigger) === 'auto') {
            _this5.trackPageView($page);
          }
        });
      }

      _this5.bindEvents();

      _this5.emit(InhouseInitReady);
    });
    this.emit(InhouseInit);
  }
  /**
   * 返回 props
   */
  ;

  _proto.getProps = function getProps() {
    return this._props;
  }
  /**
   * 设置 props
   * @param props 属性对象
   */
  ;

  _proto.setProps = function setProps(props) {
    this._props = deepMerge(this._props, props);
  }
  /**
   * 返回 sprops
   * @NOTE: 暂不需持久化存储了（storage），如后期需要，可修改此方法
   */
  ;

  _proto.getSprops = function getSprops() {
    return this._sprops;
  }
  /**
   * 设置 sprops
   * @NOTE: 暂不需持久化存储了（storage），如后期需要，可修改此方法
   * @param props 属性对象
   */
  ;

  _proto.setSprops = function setSprops(props) {
    this._sprops = deepMerge(this._sprops, props);
  };

  _proto.getFromLocalFrom = function getFromLocalFrom() {
    var rawFrom = storage.local.getRaw('from');
    var from = storage.local.get('from');
    this.innerState['hasRawFrom'] = Boolean(rawFrom);
    storage.local.remove('from');
    return from || null;
  };

  _proto.get_spm_info = function get_spm_info(maybeUrl, config) {
    var _config;

    if (config === void 0) {
      config = {};
    }

    var _this$_attrs2 = this._attrs,
        item = _this$_attrs2.item,
        module = _this$_attrs2.module,
        virtualItem = _this$_attrs2.virtualItem;
    if (this.isBot || !this.options.enableProxyClick) return maybeUrl;
    if (typeof maybeUrl !== 'string') return maybeUrl;
    var url = maybeUrl;

    var _ref = this.latestFrom || {},
        _ref$timestamp = _ref.timestamp,
        timestamp = _ref$timestamp === void 0 ? 0 : _ref$timestamp,
        _ref$clickSpm = _ref.clickSpm,
        clickSpm = _ref$clickSpm === void 0 ? '' : _ref$clickSpm,
        _ref$clickId = _ref.clickId,
        clickId = _ref$clickId === void 0 ? '' : _ref$clickId,
        _ref$targeSrc = _ref.targeSrc,
        targeSrc = _ref$targeSrc === void 0 ? '' : _ref$targeSrc;

    var duration = ((_config = config) === null || _config === void 0 ? void 0 : _config.duration) || 0;
    var range = getNow() - (timestamp + duration);

    var checkUrlInTarget = function checkUrlInTarget(href, targetHref) {
      if (!href || !targetHref) return false;
      var targetArr = targetHref.split('?');
      var hrefArr = href.split('?');
      if (targetArr[0] !== hrefArr[0]) return false;
      if (href === targetHref) return true;

      if (typeof URL === 'function') {
        try {
          var t1 = new URL(targetHref, window.location.origin);
          var h1 = new URL(href, window.location.origin);
          if (t1.pathname !== h1.pathname) return false;
          t1.searchParams["delete"]('spm');
          t1.searchParams["delete"]('clickId');
          t1.searchParams.sort();
          h1.searchParams.sort();
          if (t1.search !== h1.search) return false;
          if (t1.hash !== h1.hash) return false;
          return true;
        } catch (e) {
          return false;
        }
      }

      return false;
    };

    if (range < 50 && clickSpm || checkUrlInTarget(url, targeSrc)) {
      url = joinClickSpmToUrl(url, clickSpm, clickId);
    } else {
      if (window.event) {
        var target = window.event.target || window.event.currentTarget;
        var latestItem = findLatestElement(target, function (ele) {
          var _ele$hasAttribute5, _ele$hasAttribute6, _ele$hasAttribute7;

          if (ele !== null && ele !== void 0 && (_ele$hasAttribute5 = ele.hasAttribute) !== null && _ele$hasAttribute5 !== void 0 && _ele$hasAttribute5.call(ele, item) || ele !== null && ele !== void 0 && (_ele$hasAttribute6 = ele.hasAttribute) !== null && _ele$hasAttribute6 !== void 0 && _ele$hasAttribute6.call(ele, virtualItem)) {
            return 1;
          }

          if (ele !== null && ele !== void 0 && (_ele$hasAttribute7 = ele.hasAttribute) !== null && _ele$hasAttribute7 !== void 0 && _ele$hasAttribute7.call(ele, module)) {
            return -1;
          }

          return 0;
        });
        var spmItem = latestItem;

        if (spmItem) {
          var spm = this.collectSpm(spmItem);

          if (!spm.code || !spm.page || !spm.module || !spm.item) {
            this._logger.warn('Get_spm_info not found spm info', spm);
          } else {
            var __tracker = (spmItem === null || spmItem === void 0 ? void 0 : spmItem.__virtualTracker__) || (spmItem === null || spmItem === void 0 ? void 0 : spmItem.__tracker__);

            url = joinClickSpmToUrl(url, spm.code, clickId || (__tracker === null || __tracker === void 0 ? void 0 : __tracker.clickId) || '');
          }
        }
      }
    }

    this._logger.info('Get_spm_info', config, range, url, maybeUrl, _extends({}, this.latestFrom));

    this.latestFrom = {};
    return url;
  }
  /**
   * 收集追踪信息
   */
  ;

  _proto.collectFromInfo = function collectFromInfo() {
    var ref = getClickInfo();
    var localRef = this.getFromLocalFrom();
    ref = _extends({}, ClickEmpty, localRef, ref);
    return {
      clickId: ref.clickId,
      clickSpm: ref.clickSpm,
      timestamp: (localRef === null || localRef === void 0 ? void 0 : localRef.timestamp) || ref.clickSpm && Date.now() || -1
    };
  }
  /**
   * 收集 page 节点 & 附加追踪信息
   * @param el dom 节点
   */
  ;

  _proto.collectPageNodes = function collectPageNodes(el) {
    var _this6 = this;

    if (el === void 0) {
      el = document;
    }

    var attrName = this._attrs.page;
    var $pages = el.querySelectorAll("[" + attrName + "]");
    $pages.forEach(function ($page) {
      return _this6.attachTrackInfoToDom(attrName, $page);
    });
    return Array.from($pages);
  }
  /**
   * 收集 module 节点 & 附加追踪信息
   * @param el dom 节点
   */
  ;

  _proto.collectModuleNodes = function collectModuleNodes(el) {
    var _this7 = this;

    if (el === void 0) {
      el = document;
    }

    var attrName = this._attrs.module;
    var $modules = el.querySelectorAll("[" + attrName + "]");
    $modules.forEach(function ($module) {
      return _this7.attachTrackInfoToDom(attrName, $module);
    });
    return Array.from($modules);
  }
  /**
   * 收集 item 节点 & 附加追踪信息
   * @param el dom 节点
   */
  ;

  _proto.collectItemNodes = function collectItemNodes(el) {
    var _this8 = this;

    if (el === void 0) {
      el = document;
    }

    var attrName = this._attrs.item;
    var $items = el.querySelectorAll("[" + attrName + "]");
    $items.forEach(function ($item) {
      return _this8.attachTrackInfoToDom(attrName, $item);
    });
    return Array.from($items);
  }
  /**
   * 收集 virtualItem 节点 & 附加追踪信息
   * @param el dom 节点
   */
  ;

  _proto.collectVirtualItemNodes = function collectVirtualItemNodes(el) {
    var _this9 = this;

    if (el === void 0) {
      el = document;
    }

    var attrName = this._attrs.virtualItem;
    var $virtualItems = el.querySelectorAll("[" + attrName + "]");
    $virtualItems.forEach(function ($virtualItem) {
      return _this9.attachTrackInfoToDom(attrName, $virtualItem);
    });
    return Array.from($virtualItems);
  }
  /**
   * set spm path info to tracking element
   * @param el relavent element
   * @param isVirtual is virtual item element
   */
  ;

  _proto.attachSpmToDom = function attachSpmToDom(el, isVirtual) {
    if (isVirtual === void 0) {
      isVirtual = false;
    }

    var spm = this.collectSpm(el);
    var trackVal = isVirtual ? el.__virtualTracker__ : el.__tracker__;
    var code = spm.code;

    if (code && trackVal && !trackVal.spm && !/[{}]/.test(code)) {
      trackVal.spm = spm;
    }
  }
  /**
   * 附加信息到 dom 节点上
   * @param type 埋点类型
   * @param el dom 节点
   */
  ;

  _proto.attachTrackInfoToDom = function attachTrackInfoToDom(type, el) {
    var _this$_attrs3 = this._attrs,
        page = _this$_attrs3.page,
        module = _this$_attrs3.module,
        item = _this$_attrs3.item,
        virtualItem = _this$_attrs3.virtualItem;
    var spm = el.getAttribute(type);
    var binding = this.parseBinding(spm);

    if (!binding) {
      return;
    }

    var attachOpt = {
      // [+-]: 是否attach; 1, 2, 3, 4 代表: page, module, item, virtual
      spmStatus: 0
    };

    if (type === virtualItem) {
      el.__virtualTracker__ = {
        value: binding.value,
        virtualValue: binding.virtualValue,
        trigger: binding.trigger || 'auto',
        event: binding.event || 'click',
        modifier: binding.modifier || '',
        type: binding.type,
        objectId: binding.objectId,
        extra: binding.extra
      };
      attachOpt.spmStatus = 4;
    }

    if (type === page) {
      var pageId = this.uuid_version();
      var __tracker__ = el.__tracker__; // the same page value, and the same pageId

      if ((__tracker__ === null || __tracker__ === void 0 ? void 0 : __tracker__.value) === binding.value) {
        pageId = __tracker__.pageId || pageId;
      }
      el.__tracker__ = {
        value: binding.value,
        trigger: binding.trigger || 'auto',
        objectId: binding.objectId,
        extra: binding.extra,
        pageId: pageId,
        _from: binding._from
      };
    } else if (type === module) {
      var _tracker__ = el.__tracker__ || {};

      var isSame = _tracker__.value === binding.value && binding.value;
      var extendProps = {};

      var _time = isSame ? _tracker__.time : undefined;

      if (!isSame) {
        var exposureRate = this.calculateModuleExposureRatio(el);

        if (exposureRate >= 0.8) {
          _time = getNow();
        }
      } // 重新收集


      _tracker__.spm = undefined;

      var _spm = this.collectSpm(el);

      if (_spm.page && _spm.module) {
        extendProps = _extends({}, extendProps, {
          spm: _spm
        });
      }

      extendProps = _extends({}, extendProps, {
        time: _time
      });
      el.__tracker__ = _extends({}, extendProps, {
        value: binding.value,
        trigger: binding.trigger || 'auto',
        objectId: binding.objectId,
        index: binding.index,
        length: binding.length,
        extra: binding.extra
      });
      attachOpt.spmStatus = 2;
    } else if (type === item) {
      el.__tracker__ = {
        value: binding.value,
        trigger: binding.trigger || 'auto',
        event: binding.event || 'click',
        modifier: binding.modifier || '',
        type: binding.type,
        objectId: binding.objectId,
        extra: binding.extra
      };
      attachOpt.spmStatus = 3;
    }

    if (attachOpt.spmStatus > 0) {
      // attachSpm
      this.attachSpmToDom(el, attachOpt.spmStatus === 4);
    }
  }
  /**
   * dom ready
   * @param callback 回调
   */
  ;

  _proto.onDomReady = function onDomReady(callback) {
    if (document.readyState !== 'loading') {
      callback();
    } else {
      window.addEventListener('DOMContentLoaded', callback, false);
    }
  }
  /**
   * 绑定各种事件
   */
  ;

  _proto.bindEvents = function bindEvents() {
    this.bindItemsEvent();
    this.bindVirtualItemsEvent();
    this.observerModules();
    this.observerDomChange();
    this.onPageStateChange();
    this.onPageHide();
  }
  /**
   * 绑定 item 事件
   * @param $items item 节点列表
   */
  ;

  _proto.bindItemsEvent = function bindItemsEvent($items) {
    var _this10 = this;

    if ($items === void 0) {
      $items = this.$items;
    }

    $items.forEach(function ($item) {
      // 优先取virtual-item 的配置
      var _ref2 = $item.__virtualTracker__ || $item.__tracker__ || {},
          trigger = _ref2.trigger,
          event = _ref2.event,
          modifier = _ref2.modifier;

      if (trigger !== 'auto') {
        return;
      }

      if ($item.removeEventListeners) {
        $item.removeEventListeners(event);
      }

      if ($item.addCustomEventListener) {
        $item.addCustomEventListener(event, function (e) {
          modifier.includes('stop') && e.stopPropagation();
          modifier.includes('prevent') && e.preventDefault();

          _this10.trackAction($item);
        }, {
          capture: modifier.includes('capture'),
          once: modifier.includes('once')
        });
      }
    });
  }
  /**
   * 绑定 virtualItem 事件
   * @param $virtualItems item 节点列表
   */
  ;

  _proto.bindVirtualItemsEvent = function bindVirtualItemsEvent($virtualItems) {
    var _this11 = this;

    if ($virtualItems === void 0) {
      $virtualItems = this.$virtualItems;
    }

    $virtualItems.forEach(function ($virtualItem) {
      var _ref3 = $virtualItem.__virtualTracker__ || {},
          trigger = _ref3.trigger,
          event = _ref3.event,
          modifier = _ref3.modifier;

      if (trigger !== 'auto') {
        return;
      }

      if ($virtualItem.removeEventListeners) {
        $virtualItem.removeEventListeners(event);
      }

      if ($virtualItem.addCustomEventListener) {
        $virtualItem.addCustomEventListener(event, function (e) {
          modifier.includes('stop') && e.stopPropagation();
          modifier.includes('prevent') && e.preventDefault();

          _this11.trackVirtualAction($virtualItem);
        }, {
          capture: modifier.includes('capture'),
          once: modifier.includes('once')
        });
      }
    });
  };

  _proto.collectAndSetSpm = function collectAndSetSpm($modules) {
    var _this12 = this;

    if (!$modules.length) return;

    this._logger.info('Ready to collect spm');

    var documentContains = function documentContains(m) {
      try {
        var _document$body;

        if ((_document$body = document.body) !== null && _document$body !== void 0 && _document$body.contains && document.body.contains(m)) return true;
      } catch (e) {
        return true;
      }

      return false;
    };

    var toCollect = function toCollect($module, cb) {
      if (!documentContains($module)) return;

      var spm = _this12.collectSpm($module);

      if (spm.code && spm.page && spm.module) {
        $module.__tracker__.spm = spm;
      } else {
        _this12._logger.warn('IntersectionObserver Invalid spm:', spm);

        cb && setTimeout(cb, 200);
      }
    };

    $modules.forEach(function ($module) {
      retry(toCollect, {
        count: 4,
        args: $module
      });
    });
  }
  /**
   * 创建一个曝光监听器
   */
  ;

  _proto.createIntersectionObserver = function createIntersectionObserver() {
    var _this13 = this;

    var exposureRate = this.options.exposureRate || 0.8;

    try {
      return new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var $module = entry.target;
          var __tracker__ = $module.__tracker__;

          if (!__tracker__) {
            _this13.attachTrackInfoToDom(_this13._attrs.module, $module);
          }

          $module.__tracker__ = $module.__tracker__ || {};

          if (entry.isIntersecting) {
            var _$module$__tracker__;

            $module.__tracker__.time = Date.now(); // @NOTE: Fix spm undefined when dom was removed

            if (!((_$module$__tracker__ = $module.__tracker__) !== null && _$module$__tracker__ !== void 0 && _$module$__tracker__.spm)) {
              _this13.collectAndSetSpm([$module]);
            }
          } else {
            $module.__tracker__.trigger === 'auto' && _this13.trackExposure($module);
          }
        });
      }, {
        threshold: exposureRate || 0.8
      });
    } catch (error) {
      this._logger.error(error);

      return null;
    }
  };

  _proto.enqueueTask = function enqueueTask(taskCb) {
    var _this14 = this;

    setTimeout(function () {
      return taskCb.call(_this14);
    }, 0);
  };

  _proto.processRemovedNode = function processRemovedNode(removedNodes) {
    var _this15 = this;

    if (!removedNodes.length) return; // @NOTE: Ignore，如需处理 dom 移除，可在此操作

    var module = this._attrs.module; // let $modules: ModuleElement[] = []

    removedNodes.forEach(function (node) {
      // 如果是非元素节点，则不处理
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
      } // 1.异步收集，避免耗时过多，带来卡顿
      // this.enqueueTask(() => {
      //   const $el = node as BaseElement
      //   // 收集节点自身埋点
      //   if ($el.getAttribute(module)) {
      //     this.attachTrackInfoToDom(module, $el)
      //     $modules.push($el as ModuleElement)
      //   }
      //   // 收集子节点埋点
      //   $modules = $modules.concat(this.collectModuleNodes($el))
      // })

    });
    this.enqueueTask(function () {
      _this15.$modules = Array.from(document.querySelectorAll("[" + module + "]"));
    }); // 2.由于 1 是异步的，故这里也异步
    // this.enqueueTask(() => {
    //   if ($modules.length) {
    //     this.$modules = this.$modules.filter(module => {
    //       return !$modules.some(deletedModule => {
    //         const deletedTracker = deletedModule.__tracker__
    //         const {
    //           value,
    //           index,
    //           length,
    //           extra,
    //           objectId,
    //         } = module.__tracker__
    //         return (
    //           deletedTracker.value === value &&
    //           deletedTracker.index === index &&
    //           deletedTracker.length === length &&
    //           JSON.stringify(deletedTracker.extra) ===
    //             JSON.stringify(extra) &&
    //           deletedTracker.objectId === objectId
    //         )
    //       })
    //     })
    //   }
    // })
  };

  _proto.processAddedNode = function processAddedNode(addedNodes) {
    var _this16 = this;

    if (!addedNodes.length) return;
    var _this$_attrs4 = this._attrs,
        page = _this$_attrs4.page,
        module = _this$_attrs4.module,
        item = _this$_attrs4.item,
        virtualItem = _this$_attrs4.virtualItem;
    var $pages = [];
    var $modules = [];
    var $items = [];
    var $virtualItems = [];
    addedNodes.forEach(function (node) {
      // 如果是非元素节点，则不处理
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
      }

      var $el = node; // 1.异步收集，避免耗时过多，带来卡顿

      _this16.enqueueTask(function () {
        // 收集 virtualItem 自身埋点
        if ($el.getAttribute(virtualItem)) {
          _this16.attachTrackInfoToDom(virtualItem, $el);

          $virtualItems.push($el);
        } // 收集节点自身埋点


        if ($el.getAttribute(item)) {
          _this16.attachTrackInfoToDom(item, $el);

          $items.push($el);
        } else if ($el.getAttribute(module)) {
          _this16.attachTrackInfoToDom(module, $el);

          $modules.push($el);
        } else if ($el.getAttribute(page)) {
          _this16.attachTrackInfoToDom(page, $el);

          $pages.push($el);
        } // 收集子节点埋点


        $pages = $pages.concat(_this16.collectPageNodes($el));
        $modules = $modules.concat(_this16.collectModuleNodes($el));
        $items = $items.concat(_this16.collectItemNodes($el));
        $virtualItems = $virtualItems.concat(_this16.collectVirtualItemNodes($el));

        if ($modules.length) {
          _this16.$modules = _this16.$modules.concat($modules);
        }
      });
    });
    this.enqueueTask(function () {
      // // 上报新添加节点的 pageview
      $pages.forEach(function ($page) {
        if ($page.__tracker__.trigger === 'auto') {
          _this16.trackPageView($page);
        }
      });

      _this16.observerModules($modules);

      _this16.bindItemsEvent($items);

      _this16.bindVirtualItemsEvent($virtualItems);
    });
  };

  _proto.processAttrMutation = function processAttrMutation(mutation) {
    var _$el$__tracker__,
        _this17 = this;

    // 如果属性值变更了，则重新解析
    var target = mutation.target,
        attributeName = mutation.attributeName;
    var _this$_attrs5 = this._attrs,
        module = _this$_attrs5.module,
        page = _this$_attrs5.page;
    var $el = target;
    var attr = attributeName || '';
    var value = $el.getAttribute(attr);

    this._logger.info("The " + attr + " attribute was modified: " + value);

    if (!value) return;
    if (!Object.values(this._attrs).includes(attr)) return;
    var oldValue = $el === null || $el === void 0 ? void 0 : (_$el$__tracker__ = $el.__tracker__) === null || _$el$__tracker__ === void 0 ? void 0 : _$el$__tracker__.value;
    this.attachTrackInfoToDom(attr, $el);
    var parseValue = this.parseBinding(value || '');
    var newValue = parseValue === null || parseValue === void 0 ? void 0 : parseValue.value;

    if (![module, page].includes(attr) && newValue && newValue === oldValue) {
      return;
    }

    if (attr === module) {
      this.collectAndSetSpm([$el]);
      this.enqueueTask(function () {
        return _this17.collectItemNodes($el);
      });
      this.enqueueTask(function () {
        return _this17.collectVirtualItemNodes($el);
      });
    } else if (attr === page) {
      var trigger = parseValue === null || parseValue === void 0 ? void 0 : parseValue.trigger;

      if (newValue && newValue !== oldValue && (!trigger || trigger === 'auto')) {
        this.trackPageView($el);
      }

      this.addPage($el);
      this.enqueueTask(function () {
        var collectModules = _this17.collectModuleNodes($el);

        _this17.collectAndSetSpm(collectModules);
      });
      this.enqueueTask(function () {
        return _this17.collectItemNodes($el);
      });
      this.enqueueTask(function () {
        return _this17.collectVirtualItemNodes($el);
      });
    }
  }
  /**
   * 创建一个 DOM 监听器
   */
  ;

  _proto.createMutationObserver = function createMutationObserver() {
    var _this18 = this;

    try {
      return new MutationObserver(function (mutationsList) {
        for (var _iterator = _createForOfIteratorHelperLoose(mutationsList), _step; !(_step = _iterator()).done;) {
          var mutation = _step.value;

          if (mutation.type === 'childList') {
            // 如果 dom 节点变更，添加 或 移除
            var addedNodes = mutation.addedNodes,
                removedNodes = mutation.removedNodes;

            _this18.processRemovedNode(removedNodes);

            _this18.processAddedNode(addedNodes);
          } else if (mutation.type === 'attributes') {
            _this18.processAttrMutation(mutation);
          }
        }

        _this18.processIdleMutation();
      });
    } catch (error) {
      this._logger.error(error);

      return null;
    }
  };

  _proto.runIdleTask = function runIdleTask(cb) {
    var requstIdleCb = window.requestIdleCallback;

    if (typeof requstIdleCb === 'function') {
      return requstIdleCb.call(window, cb);
    } else {
      return setTimeout(cb, 1000);
    }
  };

  _proto.cancelIdleTask = function cancelIdleTask(id) {
    if (id) {
      var cancelIdleCallback = window.cancelIdleCallback;

      if (typeof cancelIdleCallback === 'function') {
        cancelIdleCallback.call(window, id);
      } else {
        clearTimeout(id);
      }
    }
  };

  _proto.processIdleMutation = function processIdleMutation() {
    var _this19 = this;

    var innerState = this.innerState;
    this.cancelIdleTask(innerState.processIdleMutation);
    innerState.processIdleMutation = this.runIdleTask(function () {
      _this19._logger.info('Ready idle mutation');

      var $items = _this19.$items,
          $virtualItems = _this19.$virtualItems,
          $modules = _this19.$modules;

      var currentItems = _this19.collectItemNodes();

      if (currentItems.length) {
        var diffItems = currentItems.filter(function (i) {
          return !$items.includes(i);
        });

        _this19.bindItemsEvent(diffItems);
      }

      var currentVirtualItems = _this19.collectVirtualItemNodes();

      if (currentVirtualItems.length) {
        var diffVItems = currentVirtualItems.filter(function (i) {
          return !$virtualItems.includes(i);
        });

        _this19.bindVirtualItemsEvent(diffVItems);
      }

      var currentModules = _this19.collectModuleNodes();

      if (currentModules.length) {
        var diffModules = currentModules.filter(function (i) {
          return !$modules.includes(i);
        });

        _this19.observerModules(diffModules);
      }
    });
  }
  /**
   * 监控 module 曝光
   * @param $modules module 节点列表
   */
  ;

  _proto.observerModules = function observerModules($modules) {
    var _this20 = this;

    if ($modules === void 0) {
      $modules = this.$modules;
    }

    $modules.forEach(function ($module) {
      var _this20$_iobserver;

      if ($module.__observed__) {
        return;
      }

      (_this20$_iobserver = _this20._iobserver) === null || _this20$_iobserver === void 0 ? void 0 : _this20$_iobserver.observe($module);
      $module.__observed__ = true;
    });
  }
  /**
   * 取消监控 module 曝光
   * @param $modules module 节点列表
   */
  ;

  _proto.unobserverModules = function unobserverModules($modules) {
    var _this21 = this;

    if ($modules === void 0) {
      $modules = this.$modules;
    }

    $modules.forEach(function ($module) {
      var _this21$_iobserver;

      (_this21$_iobserver = _this21._iobserver) === null || _this21$_iobserver === void 0 ? void 0 : _this21$_iobserver.unobserve($module);
      $module.__observed__ = false;
    });
  }
  /**
   * 监听 dom 变更
   */
  ;

  _proto.observerDomChange = function observerDomChange() {
    var body = document.body || document.documentElement;

    if (this._mobserver) {
      var _this$_attrs6 = this._attrs,
          page = _this$_attrs6.page,
          module = _this$_attrs6.module,
          item = _this$_attrs6.item,
          virtualItem = _this$_attrs6.virtualItem;

      this._mobserver.observe(body, {
        attributeFilter: [page, module, item, virtualItem],
        attributes: true,
        childList: true,
        subtree: true
      });

      body.__hasObserved = true;
    }
  }
  /**
   * 监听页面状态变更
   * @note 如果时页面发生跳转的场景时， setInterval 内函数不会执行，即不会发起请求，故还需要额外监听 pagehide
   */
  ;

  _proto.onPageStateChange = function onPageStateChange() {
    var _this22 = this;

    var hidden, visibilityChange;

    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else {
      // @ts-ignore
      if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange'; // @ts-ignore
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
      }
    }

    if (hidden) {
      var attr = "hasBind" + visibilityChange;
      if (this.innerState[attr]) return;
      this.innerState[attr] = true;
      document.addEventListener(visibilityChange, function () {
        // @ts-ignore
        _this22.innerState.showStatus = document[hidden] ? 'hide' : 'show'; // @ts-ignore

        if (document[hidden]) {
          _this22._logger.info('pagehidden');

          _this22.unobserverModules();

          var __tracker__;

          _this22.$modules.forEach(function ($module) {
            __tracker__ = $module.__tracker__ || {};
            __tracker__.trigger === 'auto' && _this22.trackExposure($module);
          });
        } else {
          _this22._logger.info('pageshow');

          _this22.observerModules();

          _this22._requestQueue.flushQueue();
        }
      });
    } else {
      this._logger.error('Your browser does not support visibilityChange event');
    }
  }
  /**
   * 页面跳转时，trackExposure 需要立即上报
   * @note pagehide 与 visibilitychange 触发顺序见 https://github.com/w3c/page-visibility/issues/39
   */
  ;

  _proto.onPageHide = function onPageHide() {
    var _this23 = this;

    var key = 'hasPagehide';
    if (this.innerState[key]) return;
    this.innerState[key] = true;
    window.addEventListener('pagehide', function () {
      _this23._logger.info('onPageHide:pagehide');

      _this23.unobserverModules();

      var __tracker__;

      _this23.$modules.forEach(function ($module) {
        __tracker__ = $module.__tracker__ || {};
        __tracker__.trigger === 'auto' && _this23.trackExposure($module);
      });

      _this23.pageMayUnload();
    }, false);
  }
  /**
   * compose spm uri
   * @param spm spm value
   * @param query spm query string
   */
  ;

  _proto.encodeSpm = function encodeSpm$1(spm, query) {
    return encodeSpm(spm, query);
  }
  /**
   * 解析绑定信息
   * @param binding 绑定信息
   * @notice __default item 和 module 放在同一层级的唯一冲突在 value 这里
   */
  ;

  _proto.parseBinding = function parseBinding(binding) {
    var _extra,
        _this24 = this;

    if (typeof binding !== 'string') {
      return null;
    }

    var _binding$split = binding.split('?'),
        value = _binding$split[0],
        _binding$split$ = _binding$split[1],
        search = _binding$split$ === void 0 ? '' : _binding$split$;

    var query = querystring.parse(search);
    var trimValue = value.trim();

    if (!trimValue) {
      return null;
    } // 尝试解析 extra


    var extra = getQueryValue(query, 'ext');

    try {
      extra && (extra = JSON.parse(extra));
    } catch (error) {
      this._logger.error('Parse json failed in', "\"" + binding + "\"");
    }

    var obj_kvs = (_extra = extra) === null || _extra === void 0 ? void 0 : _extra.object_kvs;

    if (isObject(extra) && obj_kvs) {
      try {
        obj_kvs = JSON.parse(obj_kvs);

        if (isObject(obj_kvs)) {
          ;
          extra.object_kvs = transformObj(obj_kvs, function (val) {
            if (isObject(val)) {
              _this24._logger.warn('object_kvs only can be a key-value Object, and its value only can be String or Array');
            }

            return isObject(val) ? '' : String(val || '');
          });
        } else {
          this._logger.error("object_kvs should be a object what's type is key-value, but got type " + typeof obj_kvs);
        }
      } catch (error) {
        this._logger.error('Parse object_kvs error in ', "" + obj_kvs);
      }
    }

    var valueObj = {
      value: trimValue,
      virtualValue: ''
    };

    if (trimValue === '__virtual') {
      valueObj['value'] = '';
      valueObj['virtualValue'] = trimValue;
    }

    return _extends({}, valueObj, {
      trigger: getQueryValue(query, 'trg'),
      event: getQueryValue(query, 'evt'),
      modifier: getQueryValue(query, 'mod'),
      type: getQueryValue(query, 'typ'),
      objectId: getQueryValue(query, 'oid'),
      index: getQueryValue(query, 'idx', true),
      length: getQueryValue(query, 'len', true),
      extra: isObject(extra) ? extra : void 0,
      _from: getQueryValue(query, '_f') || getQueryValue(query, '_from')
    });
  }
  /**
   * 更新绑定信息
   * @param el 元素节点
   * @param binding 绑定信息
   */
  ;

  _proto.updateBinding = function updateBinding(el, binding, opt) {
    var _this$_attrs7 = this._attrs,
        page = _this$_attrs7.page,
        module = _this$_attrs7.module,
        item = _this$_attrs7.item,
        virtualItem = _this$_attrs7.virtualItem;
    var itemBinding = el.getAttribute(item);
    var moduleBinding = el.getAttribute(module);
    var pageBinding = el.getAttribute(page);
    var oldBinding = '';
    var type = '';

    var _opt = isString(opt) ? {
      spmType: opt,
      updateExtra: false
    } : opt;

    var spmType = _opt === null || _opt === void 0 ? void 0 : _opt.spmType;

    if (spmType === 'virtualItem') {
      itemBinding = el.getAttribute(virtualItem);

      if (itemBinding) {
        type = virtualItem;
      }
    } else if (itemBinding) {
      oldBinding = itemBinding;
      type = item;
    } else if (moduleBinding) {
      oldBinding = moduleBinding;
      type = module;
    } else if (pageBinding) {
      oldBinding = pageBinding;
      type = page;
    } // 该节点没有绑定任何信息的埋点，则不处理


    if (!type) {
      return;
    } // 如果 ext 是 object，帮忙序列化以下


    if (isObject(binding.ext)) {
      binding.ext = JSON.stringify(binding.ext);
    } // const [spm, search = ''] = oldBinding.split('?')
    // const oldQuery = querystring.parse(search)


    var _oldBinding$split = oldBinding.split('?'),
        spm = _oldBinding$split[0],
        _oldBinding$split$ = _oldBinding$split[1],
        search = _oldBinding$split$ === void 0 ? '' : _oldBinding$split$;

    var oldQuery = querystring.parse(search);

    if (_opt !== null && _opt !== void 0 && _opt.updateExtra && oldQuery.ext && binding.ext) {
      var _ext = isString(oldQuery.ext) ? JSON.parse(oldQuery.ext) : oldQuery.ext;

      var _binding_ext = binding.ext;
      var bindingExt = isString(_binding_ext) ? JSON.parse(_binding_ext) : _binding_ext;

      if (isObject(_ext) && _binding_ext) {
        binding.ext = _extends({}, _ext, bindingExt);
      }
    } // 如果 ext 是 object，帮忙序列化以下


    if (isObject(binding.ext)) {
      binding.ext = JSON.stringify(binding.ext);
    }

    var newQuery = Object.assign(oldQuery, stripUndefinedFields(binding));
    var newBinding = querystring.stringify(newQuery);
    el.setAttribute(type, spm + "?" + newBinding);
  }
  /**
   * 寻找节点
   * @param node 节点
   */
  ;

  _proto.findNode = function findNode(node) {
    var $node = null; // 处理 dom 节点

    if (node instanceof Element) {
      $node = node;
    } // 处理 dom 选择器


    if (typeof node === 'string') {
      try {
        $node = querySelector(node);
      } catch (error) {
        this._logger.error(error);
      }
    } // 如果 __tracker__ 不存在，则该节点未埋点


    if (!$node || !hasTrackerInfo($node)) {
      $node = null;
    }

    return $node;
  }
  /**
   * 把内容推到服务端
   * @param payloads 内容列表
   * @param isRetry 是否补偿上报
   * @param cb 回调函数
   */
  ;

  _proto.pushToServer = function pushToServer(payloads) {
    if (isSearchBot()) return;

    this._requestQueue.sendData(payloads);
  };

  _proto.getFromLocal = function getFromLocal(debug_cache_key) {
    var cache_value = storage.local.get(debug_cache_key);
    if (!cache_value) return cache_value;
    var cache_expire = cache_value.cache_expire;

    if (cache_expire && cache_expire <= Date.now()) {
      storage.local.remove(debug_cache_key);
      return null;
    }

    return cache_value;
  }
  /**
   * 追踪 PageView 事件
   * @param node 页面节点
   */
  ;

  _proto.trackPageView = function trackPageView(node, options) {
    var _this25 = this;

    if (options === void 0) {
      options = {};
    }

    if (node === 'all') {
      this.$pages.forEach(function (page) {
        return _this25.trackPageView(page);
      });
      return;
    }

    var $page = this.findNode(node);

    if (!$page) {
      this._logger.warn("Can't find the page node: , ", node);

      return;
    }

    this.attachTrackInfoToDom(this._attrs.page, $page);

    if ($page.__tracker__.trigger === Manual && !options.force) {
      this._logger.warn("Node is manual: If you want report, you need to set options.force eq true", node);

      return;
    }

    this.emit(BeforePageViewData, $page);
    var data = this.getPageViewData({
      eventType: 'pageview',
      spm: $page.__tracker__.value,
      page: $page.__tracker__
    });
    var scopeState = {
      data: data,
      node: $page,
      spmType: 'page',
      cbList: [],
      isCall: options.__call === 'dispatchEvent'
    };
    this.initScopeState(scopeState, options);
    this.emit(EventSpm, data);
    this.triggerTransformEvent($page, data);
    scopeState.cbList.push(function () {
      if (options.eventCallback) {
        scopeState.eventCallback = options.eventCallback;

        _this25.callHook(scopeState);
      }
    }, function () {
      _this25.checkClickIdSpm(scopeState);
    }, function (_ref4) {
      var data = _ref4.data;

      _this25._logger.info(EventPageView, data);

      _this25.emit(EventPageView, data, $page);
    }, function (_ref5) {
      var data = _ref5.data;

      _this25.waitP(data._readyQueue, function () {
        var payload = _this25.getPayload(data);

        _this25.emit(PageViewData, data);

        _this25.pushToServer(payload);
      });
    }, function () {
      _this25.syncToDom(scopeState);
    });
    this.runQueueCb(scopeState);
  };

  _proto.waitP = function waitP(p, cb) {
    if (this.getAsyncCacheData()) {
      cb();
    } else {
      Promise.resolve(p).then(function () {
        return cb();
      });
    }
  };

  _proto.checkClickIdSpm = function checkClickIdSpm(scopeState) {
    var node = scopeState.node,
        data = scopeState.data;
    var trackerData = node.__tracker__;

    if (trackerData._from === '1') {
      var actionData = this.actionQueue[0];
      if (!actionData) return;
      data.page.clickId = actionData.clickId;
      data.page.clickSpm = actionData.eventCommon.spm;
    }
  }
  /**
   * 追踪 custom 事件
   * @param node 页面节点, 与需要带上 page 信息的绑定 pageview 的 node 一致
   *
   */
  ;

  _proto.trackCustom = function trackCustom(node, customExtra) {
    var _this26 = this;

    var $page = this.findNode(node);

    if (!$page) {
      this._logger.warn("custom Can't find the page node:", node);

      return;
    }

    var transform = function transform(v) {
      return v;
    };

    if (customExtra !== null && customExtra !== void 0 && customExtra.transformData) {
      transform = customExtra.transformData;
      delete customExtra.transformData;
    }

    var customSpm = customExtra === null || customExtra === void 0 ? void 0 : customExtra.spm;
    this.emit(BeforeCustomData, $page);
    var data = this.getPageViewData({
      eventType: 'custom',
      spm: customSpm || $page.__tracker__.value,
      page: $page.__tracker__
    });
    var scopeState = {
      data: data,
      node: $page,
      spmType: 'page',
      eventCallback: customExtra === null || customExtra === void 0 ? void 0 : customExtra.eventCallback,
      cbList: [],
      isCall: (customExtra === null || customExtra === void 0 ? void 0 : customExtra.__call) === 'dispatchEvent'
    };
    this.initScopeState(scopeState, customExtra);
    scopeState.cbList.push(function () {
      if ((customExtra === null || customExtra === void 0 ? void 0 : customExtra.__call) === 'dispatchEvent') {
        _this26.callHook(scopeState);

        ['__call', 'syncToDom', 'eventCallback'].forEach(function (i) {
          if (!isNil(customExtra[i])) {
            customExtra[i] = undefined;
          }
        });
      }
    }, function (_ref6) {
      var data = _ref6.data;
      data.eventType = 'custom';
      data.customExtra = customExtra;

      if (typeof transform === 'function') {
        transform.call(_this26, data);
      }
    }, function (_ref7) {
      var data = _ref7.data;

      _this26._logger.info('event:custom', data);

      _this26.waitP(data._readyQueue, function () {
        _this26.emit(EventCustom, data, $page);

        var payload = _this26.getPayload(data);

        _this26.pushToServer(payload);
      });
    });
    this.runQueueCb(scopeState);
  };

  _proto.getExposureDuration = function getExposureDuration() {
    return this.options.exposureDuration || 500;
  }
  /**
   * 追踪 Exposure 事件
   * @param node 模块节点
   * @param instant 是否立即上报
   */
  ;

  _proto.trackExposure = function trackExposure(node, options) {
    var _this27 = this,
        _options;

    if (options === void 0) {
      options = {};
    }

    if (this.isModuleDisabled()) return;

    if (node === 'all') {
      this.$modules.forEach(function (module) {
        return _this27.trackExposure(module);
      });
      return;
    }

    var $module = this.findNode(node);

    if (!$module) {
      this._logger.warn("Can't find the module node:", node);

      return;
    }

    var _$module$__tracker__2 = $module.__tracker__,
        time = _$module$__tracker__2.time,
        trigger = _$module$__tracker__2.trigger;

    if (trigger === Manual && !options.force) {
      return;
    } // 找不到模块 或 没有开始曝光时间，则返回


    if (!time) {
      return;
    } // 小于 1s 的曝光视为无效曝光


    var duration = getNow() - time;

    if (duration < this.getExposureDuration()) {
      return;
    } // 重置曝光事件


    $module.__tracker__.time = void 0; // 收集 spm 码并缓存起来，避免下次重新收集

    var spm = this.collectSpm($module);

    if (spm.code && spm.page && spm.module) {
      $module.__tracker__.spm = spm;
    } else {
      this._logger.warn('TrackExposure Invalid spm:', spm);

      return;
    }

    var spmCode = spm.code.replace('.__virtual', '');
    var data = this.getExposureData({
      spm: spmCode,
      duration: duration,
      page: spm.page.__tracker__,
      module: spm.module.__tracker__
    });
    var scopeState = {
      data: data,
      node: $module,
      spmType: 'module',
      cbList: [],
      isCall: ((_options = options) === null || _options === void 0 ? void 0 : _options.__call) === 'dispatchEvent'
    };
    this.initScopeState(scopeState, options);
    scopeState.cbList.push(function () {
      // 触发 DOM 事件
      _this27.triggerTransformEvent($module, data);
    }, function () {
      if (options.eventCallback) {
        scopeState.eventCallback = options.eventCallback;

        _this27.callHook(scopeState);
      }
    }, function (_ref8) {
      var data = _ref8.data;

      _this27._logger.info('event:exposure', data);

      _this27.emit(EventExposure, data);

      _this27.waitP(data._readyQueue, function () {
        var payload = _this27.getPayload(data);

        _this27.pushToServer(payload);
      });
    }, function () {
      _this27.syncToDom(scopeState);
    });
    this.runQueueCb(scopeState);
  }
  /**
   * 追踪 Action 事件
   * @param node 元素节点
   */
  ;

  _proto.trackAction = function trackAction(node, options) {
    var _options2,
        _data$eventCommon3,
        _this28 = this;

    if (options === void 0) {
      options = {};
    }

    if (node === 'all') {
      this._logger.warn('Unsupport track all action event');

      return;
    }

    if (this.isBot) return;
    var $item = this.findNode(node);

    if (!$item) {
      this._logger.warn("Can't find the item node:", node);

      return;
    }

    if ($item.__virtualTracker__) {
      return this.trackVirtualAction(node, options);
    }

    var __tracker__ = $item.__tracker__ || {};

    var event = __tracker__.event,
        type = __tracker__.type,
        click_id = __tracker__.clickId; // 收集 spm 码并缓存起来，避免下次重新收集

    var spm = this.collectSpm($item);

    if (spm.code && spm.page && spm.module && spm.item) {
      $item.__tracker__.spm = spm;
    } else {
      this._logger.warn('TrackAction Invalid spm:', spm);

      return;
    } // 为每个 Action 事件生成一个标识 ID


    var clickId = this.getClickId();

    if (click_id) {
      __tracker__.clickId = clickId;
      clickId = click_id;
    }

    var spmCode = spm.code.replace('.__default', '');

    this._logger.info('current click info: ', clickId, spmCode); // 普通节点，上报它的 action 事件


    var data = this.getActionData({
      spm: spmCode,
      event: event,
      clickId: clickId,
      moduleExposureRatio: this.calculateModuleExposureRatio($item),
      page: spm.page.__tracker__,
      module: spm.module.__tracker__,
      // @ts-ignore
      item: spm.item.__tracker__
    });
    var scopeState = {
      data: data,
      node: $item,
      spmType: 'item',
      cbList: [],
      isCall: ((_options2 = options) === null || _options2 === void 0 ? void 0 : _options2.__call) === 'dispatchEvent'
    };
    this.initScopeState(scopeState, options);
    this.triggerTransformEvent($item, data);
    var commonStamp = (data === null || data === void 0 ? void 0 : (_data$eventCommon3 = data.eventCommon) === null || _data$eventCommon3 === void 0 ? void 0 : _data$eventCommon3.timestamp) || getNow();
    scopeState.cbList.push(function () {
      // 触发 DOM 事件
      if (type !== Manual) {
        _this28.setFrom({
          clickId: clickId,
          clickSpm: spmCode,
          timestamp: commonStamp
        });
      }
    }, function () {
      if (options.eventCallback) {
        scopeState.eventCallback = options.eventCallback;

        _this28.callHook(scopeState);
      }
    }, function (_ref9) {
      var data = _ref9.data;

      _this28.pushActionQueue(data);
    }, function (_ref10) {
      var data = _ref10.data;

      _this28._logger.info('event:action', data);

      _this28.waitP(data._readyQueue, function () {
        _this28.emit(EventAction, data);

        var payload = _this28.getPayload(data);

        _this28.pushToServer(payload);
      });
    }, function () {
      _this28.syncToDom(scopeState);
    });
    this.runQueueCb(scopeState);
  };

  _proto.setFrom = function setFrom(obj) {
    // storage.session.set('from', {
    //   ...obj,
    // })
    storage.local.set('from', _extends({}, obj), 15000);
    this.emit('fromChange', obj);
  }
  /**
   * 追踪 virtual item Action 事件
   * @param node 元素节点
   * @private
   */
  ;

  _proto.trackVirtualAction = function trackVirtualAction(node, options) {
    var _options3,
        _data$eventCommon4,
        _this29 = this;

    if (options === void 0) {
      options = {};
    }

    if (node === 'all') {
      this._logger.warn('Unsupport track all action event');

      return;
    }

    if (this.isBot) return;
    var $item = this.findNode(node);

    if (!$item) {
      this._logger.warn("Can't find the item node:", node);

      return;
    }

    var __tracker__ = $item.__virtualTracker__ || {};

    var event = __tracker__.event,
        type = __tracker__.type,
        click_id = __tracker__.clickId; // 收集 spm 码并缓存起来，避免下次重新收集

    var spm = this.collectSpm($item);

    if (spm.code && spm.page && spm.module && spm.item) {
      // 绑在同级 module 的 __tracker__ 上
      $item.__tracker__ && ($item.__tracker__.spm = spm);
    } else {
      this._logger.warn('TrackVirtualAction Invalid spm:', spm);

      return;
    } // 为每个 Action 事件生成一个标识 ID


    var clickId = this.getClickId();

    if (click_id) {
      __tracker__.clickId = clickId;
      clickId = click_id;
    }

    var spmCode = spm.code.replace('.__virtual', '');

    this._logger.info('current click info: clickId, spm ', clickId, spmCode); // 普通节点，上报它的 action 事件


    var data = this.getActionData({
      spm: spmCode,
      event: event,
      clickId: clickId,
      moduleExposureRatio: this.calculateModuleExposureRatio($item),
      page: spm.page.__tracker__,
      module: spm.module.__tracker__,
      // @ts-ignore
      item: spm.item.__virtualTracker__
    });
    var scopeState = {
      data: data,
      node: $item,
      spmType: 'virtualItem',
      cbList: [],
      isCall: ((_options3 = options) === null || _options3 === void 0 ? void 0 : _options3.__call) === 'dispatchEvent'
    };
    this.initScopeState(scopeState, options); // 触发 DOM 事件

    this.triggerTransformEvent($item, data);
    var commonStamp = (data === null || data === void 0 ? void 0 : (_data$eventCommon4 = data.eventCommon) === null || _data$eventCommon4 === void 0 ? void 0 : _data$eventCommon4.timestamp) || getNow();
    scopeState.cbList.push(function () {
      if (type !== Manual) {
        _this29.setFrom({
          clickId: clickId,
          clickSpm: spmCode,
          timestamp: commonStamp
        });
      }
    }, function () {
      if (options.eventCallback) {
        scopeState.eventCallback = options.eventCallback;

        _this29.callHook(scopeState);
      }
    }, function (_ref11) {
      var data = _ref11.data;

      _this29.pushActionQueue(data);
    }, function (_ref12) {
      var data = _ref12.data;

      _this29._logger.info('event:virtual:action', data);

      _this29.waitP(data._readyQueue, function () {
        _this29.emit(EventVirtualAction, data);

        var payload = _this29.getPayload(data);

        _this29.pushToServer(payload);
      });
    }, function () {
      _this29.syncToDom(scopeState);
    });
    this.runQueueCb(scopeState);
  };

  _proto.findLatestModuleDom = function findLatestModuleDom(el) {
    var currentNode = el;
    var module = this._attrs.module;

    while (currentNode && currentNode.tagName !== 'HTML') {
      if (currentNode.hasAttribute(module)) {
        return currentNode;
      }

      currentNode = currentNode.parentNode;
    }

    return null;
  };

  _proto.calculateModuleExposureRatio = function calculateModuleExposureRatio(clickEl) {
    var el = this.findLatestModuleDom(clickEl);

    if (!el || !el.getBoundingClientRect) {
      return 0;
    }

    var domRect = el.getBoundingClientRect();
    var winHeight = window.innerHeight;
    var winWidth = window.innerWidth;
    var left = domRect.left,
        right = domRect.right,
        top = domRect.top,
        bottom = domRect.bottom,
        width = domRect.width,
        height = domRect.height;
    var rectSize = width * height;
    var rectHeight = 0,
        rectWidth = 0;

    if (right <= 0 || left >= winWidth) {
      rectWidth = 0;
    } else if (left >= 0 && right <= winWidth) {
      rectWidth = width;
    } else {
      rectWidth = left < 0 ? right : winWidth - left;
    }

    if (top >= winHeight || bottom <= 0) {
      rectHeight = 0;
    } else if (top >= 0 && bottom <= winHeight) {
      rectHeight = height;
    } else {
      rectHeight = top < 0 ? bottom : winHeight - top;
    }

    return rectHeight * rectWidth / rectSize;
  }
  /**
   * trigger transform hook/event
   * Ref: https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
   * @param el 元素节点
   * @param data 数据
   */
  ;

  _proto.triggerTransformEvent = function triggerTransformEvent(el, data) {
    // 调用 transform hook
    var transform = this.options.transform;
    if (isFunction(transform)) transform(data);

    try {
      // 触发 transform dom 事件
      var customEvent = new CustomEvent('transform', {
        detail: {
          data: data
        }
      });
      el.dispatchEvent(customEvent);
    } catch (e) {
      console.warn('not supported', e);
    }
  }
  /**
   * 获取有效载荷
   * Ref: https://klook.slab.com/posts/%E7%BB%9F%E4%B8%80%E6%97%A5%E5%BF%97%E4%B8%8A%E6%8A%A5%E4%B8%8E%E5%AD%98%E5%82%A8-%E5%85%AC%E5%85%B1%E6%96%87%E6%A1%A3-loea0sfc
   * @param data 上报数据
   */
  ;

  _proto.getPayload = function getPayload(data) {
    var platform = this._props.platform;
    deepCompactObj(data);
    this.beforeDataEncode(data);
    this.emit('beforeDataEncode', data);
    var deviceId = this.getDeviceId() || this.getKeplerId();
    var userId = this.getUserId();
    var message;

    if (data.eventType === 'custom') {
      message = json2string(data, 'customExtra');
    } else {
      message = json2string(data);
    } // if (this.isDebug) {
    // this._logger.info('Transformed Data', JSON.parse(message))
    // }


    var payload = {
      type: 3,
      level: 'I',
      time: this.getTimestamp(),
      msg: encode(message),
      logVer: 1,
      uid: userId,
      isMasked: true,
      platform: platform,
      deviceId: deviceId
    };
    return payload;
  };

  _proto.getValOrEmpty = function getValOrEmpty(data, key, targetKey) {
    var _data$page, _ref13;

    var val = data === null || data === void 0 ? void 0 : (_data$page = data.page) === null || _data$page === void 0 ? void 0 : _data$page[key];
    return val ? (_ref13 = {}, _ref13[targetKey] = val, _ref13) : {};
  };

  _proto.beforeDataEncode = function beforeDataEncode(data) {
    var _data$eventCommon5,
        _this30 = this;

    if (!isInApp()) return;
    var eventType = data === null || data === void 0 ? void 0 : data.eventType;
    var spm = data === null || data === void 0 ? void 0 : (_data$eventCommon5 = data.eventCommon) === null || _data$eventCommon5 === void 0 ? void 0 : _data$eventCommon5.spm;
    if (!spm || eventType !== 'action') return;
    var unEventId = data.unique_event_id;
    var eventName = 'iht.triggerEvent';

    this._logger.info('dsBridge', spm, data.eventType);

    dsbridge.call(eventName, {
      spm: spm,
      extra_info: _extends({
        $event_id: unEventId,
        event_type: data.eventType
      }, this.getValOrEmpty(data, 'objectId', 'object_id'), this.getValOrEmpty(data, 'clickSpm', 'click_spm'), this.getValOrEmpty(data, 'clickId', 'click_id'))
    }, function (ret) {
      _this30._logger.info('dsBridge result: ', ret);
    });
  };

  _proto.checkLocal = function checkLocal() {
    var key = 'localStorageSupport';
    this.innerState[key] = storage.isSupported();
    return this.innerState[key];
  };

  _proto.getKeplerId = function getKeplerId() {
    var kepler_id = this._props.keplerId || getFromCookie('kepler_id') || '';
    return kepler_id;
  };

  _proto.getDeviceId = function getDeviceId() {
    var deviceId = this._props.deviceId || getFromCookie('kepler_id') || '';
    return deviceId;
  };

  _proto.getUserId = function getUserId() {
    var userId = this._props.userId || getFromCookie('user_id') || '';
    return userId;
  };

  _proto.getDomLoadedTime = function getDomLoadedTime() {
    var _window$performance;

    var key = "domLoadedTime";
    if (this.innerState[key]) return this.innerState[key];
    var timing = (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : _window$performance.timing;
    var domLoadedTime = 0;

    if (timing) {
      domLoadedTime = timing.domContentLoadedEventEnd - timing.navigationStart;
    }

    this.innerState[key] = domLoadedTime;
    return domLoadedTime;
  };

  _proto.uuid_version = function uuid_version() {
    return uidWithVersion();
  };

  _proto.getDebugMode = function getDebugMode() {
    var isDebug = this.isDebug,
        options = this.options;
    var debug = isDebug ? isDebug : options === null || options === void 0 ? void 0 : options.isDebugMode;
    return Boolean(debug);
  };

  _proto.resolveTimeout = function resolveTimeout(p) {
    var innerState = this.innerState; // const timeout = 'A.out';

    var key = AsyncDataCache;
    var isResolve = false; // const sNow = getNow()

    var callWhenResolved = function callWhenResolved(cb) {
      if (isResolve) return;
      isResolve = true;
      cb();
    };

    return new Promise(function (resolve) {
      p.then(function (d) {
        return callWhenResolved(function () {
          return resolve(d);
        });
      });
      setTimeout(function () {
        return callWhenResolved(function () {
          return resolve({});
        });
      }, 500);
    }).then(function (d) {
      innerState[key] = d && isObject(d) ? d : {};
      return innerState[key];
    });
  };

  _proto.getDataInfo = function getDataInfo() {
    var p = this.options.data;
    var innerState = this.innerState;
    var key = AsyncDataCache;

    if (p && isFunction(p)) {
      return this.resolveTimeout(Promise.resolve(p.call(this, this)));
    }

    innerState[key] = p && isObject(p) ? p : {};
    return Promise.resolve(innerState[key]);
  };

  _proto.getAsyncCacheData = function getAsyncCacheData() {
    return this.innerState[AsyncDataCache];
  }
  /**
   * 获取通用数据 (use public for test)
   * @param type 事件类型
   * @param props 属性参数
   */
  ;

  _proto.getCommonData = function getCommonData(type, props) {
    var _props = this._props;
    var unique_event_id = this.uuid_version(); // const clickId = props.clickId

    var pageOpenId = props.page && props.page.pageId || _props.pageId || unique_event_id;

    var referrerInfo = this._detector.getReferrer(this.getLastRef());

    var currentReferer = this._detector.getReferrerOfUrl(this.innerState['lastReferer']);

    var kid = this.localConfig.kid;
    var kepler_id = this.getKeplerId();
    var deviceId = this.getDeviceId();
    var extraProps = kid && kepler_id && kid !== kepler_id ? {
      aliasKeplerId: kid
    } : {};

    if (type === 'pageview') {
      extraProps = _extends({}, extraProps, {
        lut: getNow() - (this.localConfig.unloadT || 0),
        ck: "cl:" + (document.cookie || '').length + "; ce:" + navigator.cookieEnabled + ";"
      });
    }

    var eventCommon = this.options.eventCommon || {};
    var gaProperties = {
      engagementTimeMsec: 1,
      userId: this.getUserId()
    };

    var setGa = function setGa(res) {
      pick(gaProperties, res, ['clientId', 'sessionId']);
    };

    var dataInfo = this.getDataInfo().then(function (res) {
      setGa(res);
      return res;
    })["catch"]();
    var cacheData = this.getAsyncCacheData();

    if (cacheData) {
      setGa(cacheData);
    }

    var data = {
      isDebugMode: this.getDebugMode(),
      eventType: type,
      siteCommon: {
        siteName: _props.siteName,
        language: _props.siteLanguage,
        currency: _props.siteCurrency
      },
      eventCommon: _extends({}, this.getSessionId(), {
        timestamp: this.getTimestamp(),
        spm: props.spm,
        experiments: _props.experiments,
        keplerDeviceId: String(kepler_id || '')
      }, eventCommon),
      superProperties: Object.assign(_extends({}, extraProps, {
        $os: this._detector.os,
        $browser: this._detector.browser,
        $currentUrl: window.location.href,
        $browserVersion: this._detector.browserVersion,
        $screenHeight: this._detector.screen.height,
        $screenWidth: this._detector.screen.width,
        $deviceId: deviceId || '',
        $distinctId: _props.distinctId,
        $initialReferrer: currentReferer.referrer || this._detector.referrer,
        $initialReferringDomain: currentReferer.referringDomain || this._detector.referringDomain,
        $referrerRef: referrerInfo.referrer,
        $referringDomainRef: referrerInfo.referringDomain,
        $searchEngine: this._detector.searchEngine,
        $navigationType: this.getNavigationType(),
        $domLoadedTime: this.getDomLoadedTime(),
        $dureTime: this.getDureTime(),
        $pShow: this.innerState.showStatus,
        $uActive: this.isActive()
      }), this._sprops),
      page: {
        clickSpm: this._from.clickSpm,
        clickId: String(this._from.clickId),
        pageOpenId: pageOpenId,
        // pageOpenId: _props.pageId,
        appWebviewOs: this._detector.webviewOS || this._props.platform || void 0,
        objectId: props.page.objectId,
        extra: props.page.extra,
        is_new_page: this.getNavigationType() !== 'back_forward',
        linked_click_timestamp: +(!this._from.timestamp ? -1 : this._from.timestamp)
      },
      unique_event_id: unique_event_id,
      gaProperties: gaProperties,
      _readyQueue: dataInfo
    };
    return data;
  };

  _proto.isActive = function isActive() {
    // @ts-ignore
    var ua = navigator.userActivation || {};
    var active = ua.isActive;
    return typeof active === 'undefined' ? 'nosupp' : active ? 'yes' : 'no';
  };

  _proto.getDureTime = function getDureTime() {
    return (getNow() - this.innerState._navTime) / 1000;
  };

  _proto.getSessionId = function getSessionId$1() {
    return getSessionId();
  };

  _proto.getNavigationType = function getNavigationType() {
    var type = 'unknown';

    if (performance && performance.navigation && typeof performance.navigation.type !== 'undefined') {
      var _performance$navigati = performance.navigation,
          ctype = _performance$navigati.type,
          redirectCount = _performance$navigati.redirectCount;
      var T_Map = {
        0: 'navigate',
        1: 'reload',
        2: 'back_forward'
      };
      type = T_Map[ctype] || type;

      if (ctype === 0 && redirectCount > 0) {
        type = 'redirect';
      }

      if (type === 'unknown') {
        type = String(ctype);
      }
    } else if (performance && performance.getEntriesByType) {
      var navigation = performance.getEntriesByType('navigation')[0] || {};
      type = navigation.type;
    }

    return type;
  }
  /**
   * 获取 PageView 数据
   * @param props 属性参数
   */
  ;

  _proto.getPageViewData = function getPageViewData(props) {
    var marketing = this._props.marketing;
    var data = this.getCommonData(props.eventType ? props.eventType : 'pageview', {
      spm: props.spm,
      page: props.page
    });

    if (props.eventType === 'pageview') {
      data.unique_event_id = data.page.pageOpenId;

      if (props.page.pageId) {
        props.page.pageId = data.unique_event_id;
      }
    }

    if (marketing) {
      data.trafficCommon = _extends({}, marketing.props || {}, {
        utmSource: marketing.utmSource,
        utmMedium: marketing.utmMedium,
        utmCampaign: marketing.utmCampaign,
        utmContent: marketing.utmContent,
        utmTerm: marketing.utmTerm,
        affAid: marketing.affAid,
        affPid: marketing.affPid,
        affSid: marketing.affSid,
        affAdid: marketing.affAdid,
        klookCampaignId: marketing.campaignId,
        googleAdsId: marketing.googleAdsId,
        googleDisplayadsId: marketing.googleDisplayadsId,
        wbraid: marketing.wbraid,
        gbraid: marketing.gbraid,
        campaignId: marketing.utmId,
        referringDomain: marketing.referringDomain,
        trafficRetain: marketing.trafficRetain,
        persistedSource: marketing.persistedSource,
        googleClickSource: marketing.googleClickSource,
        trafficUpdateTimestamp: marketing.trafficUpdateTimestamp,
        channel_level_1: marketing.channel_level_1,
        klc_l1: marketing.klc_l1,
        klc_l2: marketing.klc_l2
      });
      data.trafficCommon = transformObj(data.trafficCommon, function (val) {
        return String(val || '');
      });
      var trafficCommon = data.trafficCommon;

      for (var key in trafficCommon) {
        if (trafficCommon.hasOwnProperty(key) && typeof trafficCommon[key] !== 'boolean' && !trafficCommon[key]) {
          delete trafficCommon[key];
        }
      }
    }

    return data;
  }
  /**
   * 获取 Exposure 事件数据
   * @param props 属性参数
   */
  ;

  _proto.getExposureData = function getExposureData(props) {
    var data = this.getCommonData('exposure', {
      spm: props.spm,
      page: props.page
    });
    var duration = props.duration,
        module = props.module;
    data.duration = duration;
    data.module = {
      objectId: module.objectId,
      listIndex: module.index,
      listLen: module.length,
      extra: module.extra
    };

    var isNil = function isNil(s) {
      return s !== 0 && !s;
    };

    if (props.spm.toLowerCase().includes('_list') && (isNil(data.module.listLen) || isNil(data.module.listIndex))) {
      this._logger.warn('Module lack of listLen or listIndex', data);
    }

    return data;
  }
  /**
   * 获取 Action 事件数据
   * @param props 属性参数
   */
  ;

  _proto.getActionData = function getActionData(props) {
    var spm = props.spm,
        page = props.page,
        module = props.module,
        item = props.item,
        clickId = props.clickId,
        moduleExposureRatio = props.moduleExposureRatio;
    var data = this.getCommonData('action', {
      spm: spm,
      page: page,
      clickId: clickId
    });
    data.module = {
      objectId: module.objectId,
      listIndex: module.index,
      listLen: module.length,
      extra: module.extra
    };
    data.item = {
      objectId: item.objectId,
      extra: item.extra
    };
    data.clickId = props.clickId;
    data.unique_event_id = props.clickId;
    data.actionType = props.event;
    data.module_exposure_ratio = moduleExposureRatio || 0;
    return data;
  }
  /**
   * 收集 spm 码
   * @param el 元素节点
   */
  ;

  _proto.collectSpm = function collectSpm(el) {
    var _this$_attrs8 = this._attrs,
        page = _this$_attrs8.page,
        module = _this$_attrs8.module,
        item = _this$_attrs8.item,
        virtualItem = _this$_attrs8.virtualItem;
    var spm = {}; // 如果该节点已收集过了，直接返回

    if (el.__tracker__ && el.__tracker__.spm) {
      return el.__tracker__.spm;
    }

    while (el && el.tagName !== 'HTML') {
      var _el = el;
      el = el.parentNode;

      var virtualItemSpm = _el.getAttribute(virtualItem);

      if (virtualItemSpm && _el.__virtualTracker__ && !spm.page && !spm.module && !spm.item) {
        spm.code = '{page}.{module}.{item}';
        spm.item = _el;
        spm.code = spm.code.replace('{item}', _el.__virtualTracker__.virtualValue || _el.__virtualTracker__.value || '');
      }

      var itemSpm = _el.getAttribute(item);

      if (itemSpm && _el.__tracker__ && !spm.page && !spm.module && !spm.item) {
        spm.code = '{page}.{module}.{item}';
        spm.item = _el;
        spm.code = spm.code.replace('{item}', _el.__tracker__.value);
        continue;
      }

      var moduleSpm = _el.getAttribute(module);

      if (moduleSpm && _el.__tracker__ && !spm.page && !spm.module) {
        spm.code = spm.code || '{page}.{module}';
        spm.module = _el;
        spm.code = spm.code.replace('{module}', _el.__tracker__.value);
        continue;
      }

      var pageSpm = _el.getAttribute(page);

      if (pageSpm && _el.__tracker__ && !spm.page) {
        spm.code = spm.code || '{page}';
        spm.page = _el;
        spm.code = spm.code.replace('{page}', _el.__tracker__.value);
        break;
      }
    }

    if (spm.code) {
      var spmCode = spm.code;
      spmCode = spmCode.replace('.__virtual', '');
      spmCode = spmCode.replace('.__default', '');
      spm.code = spmCode;
    }

    return spm;
  }
  /**
   * 生成 click id 用于标识每个点击
   */
  ;

  _proto.getClickId = function getClickId() {
    return this.uuid_version();
  }
  /**
   * 统一上报事件
   * @param event 事件名称
   * @param node 节点
   * @param customExtra customEvent 上报所需 extra 信息
   */
  ;

  _proto.track = function track(event, node, customExtra) {
    var supportEvents = ['pageview', 'exposure', 'action', 'custom', 'virtualAction'];
    if (this.isBot) return;

    if (!supportEvents.includes(event)) {
      this._logger.warn("Unsupport event: " + event + ", avaliable events: " + supportEvents.join(', '));

      return;
    }

    if (!this._isReady) {
      var args = [].slice.apply(arguments);

      this._callbackQueue.push(args);

      return;
    }

    var handleEventObject = {
      pageview: this.trackPageView,
      exposure: this.trackExposure,
      action: this.trackAction,
      virtualAction: this.trackVirtualAction,
      custom: this.trackCustom
    };

    if (handleEventObject[event]) {
      handleEventObject[event].call(this, node, // @ts-ignore
      Object.assign({
        force: true
      }, customExtra));
    }
  };

  _proto.assert = function assert(cond, errorMessage, level) {
    if (level === void 0) {
      level = 'error';
    }

    if (cond) {
      this._logger[level](errorMessage);

      return true;
    }

    return false;
  };

  _proto.detectSpmType = function detectSpmType(node, spmType) {
    var type;
    var _this$_attrs9 = this._attrs,
        module = _this$_attrs9.module,
        page = _this$_attrs9.page,
        virtualItem = _this$_attrs9.virtualItem,
        item = _this$_attrs9.item;

    if (spmType === 'virtualItem') {
      type = node !== null && node !== void 0 && node.hasAttribute(virtualItem) ? 'virtualItem' : 'item';
    } else {
      if (node.hasAttribute(page)) {
        type = 'page';
      } else if (node.hasAttribute(module)) {
        type = 'module';
      } else if (node.hasAttribute(item)) {
        type = 'item';
      }
    }

    return type;
  };

  _proto.dispatchEvent = function dispatchEvent(event, eventCallback) {
    if (this.assert(!event || !event.node, new Error('dispatchEvent: parameter is required'))) return;
    var domNode = isString(event.node) ? querySelector(event.node) : event.node;
    var node = domNode;
    if (this.assert(!node, new Error("dispatchEvent: cann't find node!"))) return;

    var eventOpt = _extends({}, event, {
      node: node,
      syncToDom: isNil(event.syncToDom) ? event.spmType !== 'custom' : event.syncToDom
    });

    var spmType = this.detectSpmType(node, eventOpt.spmType);
    if (this.assert(!spmType, "dispatchEvent: cann't find spm info!")) return;
    var config = {
      force: true,
      syncToDom: eventOpt.syncToDom,
      eventCallback: eventCallback,
      __call: 'dispatchEvent'
    };

    if (spmType === 'item' || spmType === 'virtualItem') {
      this.trackAction(node, config);
    } else if (spmType === 'module') {
      this.trackExposure(node, config);
    } else if (spmType === 'custom') {
      this.trackCustom(node, config);
    } else if (spmType === 'page') {
      this.trackPageView(node, config);
    } else {
      this._logger.error(new Error("Can not find expected type:  \"" + spmType));
    }
  };

  _proto.callHook = function callHook(info) {
    var _info$eventCallback = info.eventCallback,
        eventCallback = _info$eventCallback === void 0 ? {} : _info$eventCallback,
        data = info.data,
        node = info.node,
        spmType = info.spmType;
    var afterCollect = eventCallback.afterCollect;
    var result = data;
    var dataLayer = [];

    var checkReset = function checkReset(record, type) {

      var keyMap = {
        ext: 'extra',
        oid: 'objectId'
      };
      forEach(keyMap, function (item, key) {
        var _record$type;

        var k = key;

        if ((_record$type = record[type]) !== null && _record$type !== void 0 && _record$type[k]) {
          var typeRecord = record[type];
          typeRecord[item] = typeRecord[k];
          delete typeRecord[k];
        }
      });
    };

    var setData = function setData(record) {
      checkReset(record, spmType);
      dataLayer.push(record);
    };

    if (afterCollect) {
      var trackerData = node[spmType === 'virtualItem' ? '__virtualTracker__' : '__tracker__'];
      var cbData = {
        eventData: data,
        setData: setData
      };
      var key = SpmKeyMap[spmType];
      cbData[key] = trackerData;
      afterCollect(cbData);
      info.data = mergeData(data, dataLayer);
      info.dataLayer = dataLayer;
    }

    return result;
  };

  _proto.initScopeState = function initScopeState(scopeState, options) {
    var _options4;

    if (options === void 0) {
      options = {};
    }

    if ((_options4 = options) !== null && _options4 !== void 0 && _options4.syncToDom) {
      scopeState.syncToDom = true;
    }
  };

  _proto.runQueueCb = function runQueueCb(scopeState) {
    runQueue(scopeState.cbList, function (cb, next) {
      cb(scopeState);
      next();
    });
  }
  /**
   * 更新dom上的埋点数据
   *
   * @example <div id="test1" data-spm-page="test" />
   * inhouse.update2Dom('#test1', 'page', { page: { objectId: '1212' } }
   * dom#test1 -> <div id="test1" data-spm-page="test?oid=1212" />
   *
   * @param selector Element | string node 节点或者选择器
   * @param spmType 'page' | 'module' | 'item' | 'virtualItem' 节点上的埋点数据类型
   * @param dataLayer { item, page, module } 要更新的埋点数据 data-spm-item 对应 spmType=item, 其他依次对应
   *
   */
  ;

  _proto.update2Dom = function update2Dom(selector, spmType, dataLayer) {
    var node = isString(selector) ? querySelector(selector) : selector;
    if (!node) return;
    this.syncToDom({
      node: node,
      spmType: spmType,
      data: {},
      cbList: [],
      isCall: true,
      syncToDom: true,
      dataLayer: [dataLayer]
    });
  };

  _proto.syncToDom = function syncToDom(scopeState) {
    var node = scopeState.node,
        spmType = scopeState.spmType,
        dataLayer = scopeState.dataLayer,
        isCall = scopeState.isCall,
        syncToDom = scopeState.syncToDom;
    if (!isCall || !syncToDom) return;
    var keyMap = {
      objectId: 'oid',
      extra: 'ext',
      index: 'idx',
      listIndex: 'idx',
      length: 'len',
      listLen: 'len'
    };
    var syncData = {};

    if (['page', 'item', 'module', 'virtualItem'].includes(spmType)) {
      var key = SpmKeyMap[spmType];
      forEach(dataLayer, function (item) {
        var itemData = item && item[key] || {};
        forEach(itemData, function (val, key) {
          if (keyMap[key]) {
            syncData[keyMap[key]] = val;
          } else {
            syncData[key] = val;
          }
        });
      });
    }

    if (Object.keys(syncData).length) {
      this.updateBinding(node, syncData, {
        spmType: spmType,
        updateExtra: true
      });
    }
  };

  _proto.pushActionQueue = function pushActionQueue(data) {
    this.actionQueue.unshift(data);

    if (this.actionQueue.length > 3) {
      this.actionQueue.pop();
    }
  }
  /**
   * 内部状态查询
   * @param opt
   */
  ;

  _proto.queryData = function queryData(opt) {
    var _this31 = this,
        _action0$eventCommon;

    if (opt === void 0) {
      opt = {};
    }

    opt = opt || {};

    if (opt.node && opt.spmType) {
      var _opt2 = opt,
          spmType = _opt2.spmType,
          node = _opt2.node;

      var _node = typeof node === 'string' ? querySelector(node) : node;

      if (!_node) {
        this._logger.error("queryData: node " + node + " not found, spmType: " + spmType);
      }

      var spmAttrValue = this._attrs[spmType];
      var el = _node;

      if (opt.nearSpm) {
        var keys = Object.keys(this._attrs).map(function (k) {
          return _this31._attrs[k];
        });
        var latestNode = findLatestElement(el, function (ele) {
          var _ele$hasAttribute9;

          if (!spmAttrValue) return keys.some(function (i) {
            var _ele$hasAttribute8;

            return ele === null || ele === void 0 ? void 0 : (_ele$hasAttribute8 = ele.hasAttribute) === null || _ele$hasAttribute8 === void 0 ? void 0 : _ele$hasAttribute8.call(ele, i);
          }) ? 1 : 0;
          return ele !== null && ele !== void 0 && (_ele$hasAttribute9 = ele.hasAttribute) !== null && _ele$hasAttribute9 !== void 0 && _ele$hasAttribute9.call(ele, spmAttrValue) ? 1 : 0;
        }, {
          stopTag: null
        });
        el = latestNode;
      }

      if (!el) return {};
      this.attachTrackInfoToDom(spmAttrValue, el);
      var trackerData = spmType === 'virtualItem' ? el.__virtualTracker__ : el.__tracker__ || el.__virtualTracker__;
      var spm = this.collectSpm(node);
      return _extends({}, trackerData, {
        currentValue: trackerData === null || trackerData === void 0 ? void 0 : trackerData.value,
        spm: spm.code,
        spmInfo: _extends({}, spm)
      });
    }

    var action0 = this.actionQueue[0];
    var page0 = this.$pages[0];
    page0 && this.attachTrackInfoToDom('data-spm-page', page0);
    var pageTracker = (page0 === null || page0 === void 0 ? void 0 : page0.__tracker__) || {};
    return {
      clickFrom: _extends({}, this._from),
      firstClickInfo: _extends({}, action0 || {}, {
        clickId: action0 === null || action0 === void 0 ? void 0 : action0.clickId,
        clickSpm: action0 === null || action0 === void 0 ? void 0 : (_action0$eventCommon = action0.eventCommon) === null || _action0$eventCommon === void 0 ? void 0 : _action0$eventCommon.spm
      }),
      pageInfo: _extends({}, pageTracker, {
        pageOpenId: pageTracker.pageId,
        pageSpm: pageTracker.value
      }),
      prop: this._props
    };
  };

  return Tracker;
}(eventemitter3);

var tracker = /*#__PURE__*/new Tracker();

if (typeof window !== 'undefined') {
  window.__in_house = tracker;
}

export default tracker;
//# sourceMappingURL=klookinhouse.esm.js.map
